/* push 1777643583460 */
(function(){
  var el=document.getElementById('mes-config');
  if(!el)return;
  var cfg=JSON.parse(el.textContent);
  var TN=cfg.TN,CDN='https://'+TN+'.myshopishop.com';
  var CURRENCY=cfg.CURRENCY||'AUD';
  var IS_HOME=!!cfg.IS_HOME;
  // Locale: US/CA say "mom", everywhere else says "mum" (AU/NZ/UK/IE/SG/EU).
  // Set once at module init from window.Shopify.country.iso_code.
  var __country=(window.Shopify&&window.Shopify.country&&window.Shopify.country.iso_code)||'';
  var IS_MOM=__country==='US'||__country==='CA';
  var MUM=IS_MOM?'mom':'mum';
  var MUM_CAP=IS_MOM?'Mom':'Mum';
  var MUMS=IS_MOM?'moms':'mums';
  function localizeMum(s){
    if(!IS_MOM||!s)return s||'';
    return String(s)
      .replace(/\bMUMS\b/g,'MOMS').replace(/\bMUM\b/g,'MOM')
      .replace(/\bMums\b/g,'Moms').replace(/\bMum\b/g,'Mom')
      .replace(/\bmums\b/g,'moms').replace(/\bmum\b/g,'mom');
  }
  // Products: P[0]-P[8] — all 9 products across all stages
  // 0=Mat Leggings 7/8, 1=Nursing Crop, 2=Mat Shorts, 3=Rec Leggings 7/8, 4=Rec Shorts
  // 5=Shaper Move Shorts+Pockets, 6=7/8 Shaper Move+Pockets, 7=Long Line Crop, 8=Body Shapewear Shorts+Pockets
  var P=cfg.P||[];
  var RRP_PER=[cfg.P1_RRP||140,cfg.P2_RRP||120,cfg.P3_RRP||120,cfg.P4_RRP||130,cfg.P5_RRP||130,cfg.P6_RRP||120,cfg.P7_RRP||120,cfg.P8_RRP||120,cfg.P9_RRP||130];
  var SIZES=['XXS','XS','S','M','L','XL','XXL','XXXL'];

  // PDP context: current product for single-item purchase
  var PDP_HANDLE=cfg.PDP_HANDLE||null;
  var PDP_NAME=cfg.PDP_NAME||null;
  var PDP_PRICE=cfg.PDP_PRICE||null;
  var PDP_VARIANTS=cfg.PDP_VARIANTS||null;

  // Auto-fit text to container width
  function fitAllText(){
    document.querySelectorAll('.mes-fit-text').forEach(function(el){
      if(!el.parentElement||el.offsetParent===null)return;
      var maxW=el.parentElement.clientWidth;
      if(maxW<=0)return;
      // Start smaller on mobile
      var sz=maxW<500?28:48;
      el.style.fontSize=sz+'px';
      while(el.scrollWidth>maxW&&sz>8){
        sz-=0.5;
        el.style.fontSize=sz+'px';
      }
    });
  }
  window.addEventListener('resize',function(){requestAnimationFrame(fitAllText);});

  // Desktop scroll arrows for carousels (desktop only)
  function addScrollArrows(track){
    if(!window.matchMedia('(min-width:768px)').matches||!track)return;
    var wrap=track.parentElement;
    if(!wrap)return;
    if(getComputedStyle(wrap).position==='static')wrap.style.position='relative';
    if(wrap.querySelector('.mes-scroll-arrow'))return;
    var btnCss='position:absolute;top:50%;transform:translateY(-50%);width:36px;height:36px;border-radius:50%;background:rgba(0,0,0,0.6);color:#fff;border:none;font-size:18px;cursor:pointer;z-index:5;display:none;align-items:center;justify-content:center;';
    var left=document.createElement('button');left.type='button';left.className='mes-scroll-arrow';
    left.style.cssText=btnCss+'left:6px;';left.innerHTML='\u2039';
    var right=document.createElement('button');right.type='button';right.className='mes-scroll-arrow';
    right.style.cssText=btnCss+'right:6px;';right.innerHTML='\u203A';
    wrap.appendChild(left);wrap.appendChild(right);
    function update(){
      var sl=track.scrollLeft,max=track.scrollWidth-track.clientWidth;
      left.style.display=sl>10?'flex':'none';
      right.style.display=max-sl>10?'flex':'none';
    }
    left.addEventListener('click',function(e){e.stopPropagation();track.scrollBy({left:-track.clientWidth*0.8,behavior:'smooth'});});
    right.addEventListener('click',function(e){e.stopPropagation();track.scrollBy({left:track.clientWidth*0.8,behavior:'smooth'});});
    track.addEventListener('scroll',update);
    // Check repeatedly until layout is ready
    var checks=0;
    var iv=setInterval(function(){
      update();
      checks++;
      if(checks>20)clearInterval(iv);
    },200);
  }
  var STAGES=[{v:'t1',l:'1st'},{v:'t2',l:'2nd'},{v:'t3',l:'3rd'},{v:'pp',l:'post<br>partum'},{v:'ml',l:MUM+'<br>life'}];

  // Stage group: pregnancy (t1/t2/t3), postpartum (pp), mumlife (ml)
  function getStageGroup(triVal){
    if(triVal==='pp')return 'postpartum';
    if(triVal==='ml')return 'mumlife';
    return 'pregnancy';
  }

  function getFlashSaleApi(){
    return window.__emFlashSale||null;
  }

  function getFlashSaleState(){
    var flashSale=getFlashSaleApi();
    if(!flashSale)return{active:false,remainingMs:0};
    return flashSale.getState();
  }

  function getPdpInitialTri(handle){
    if(!handle)return 't2';
    if(handle==='7-8-shaper-move-leggings-pockets-black'||handle==='long-line-crop-black'||handle==='body-shapewear-shorts-pockets'||handle==='shorts-shaper-move-pockets-black')return 'ml';
    if(handle==='pregnancy-recovery-emama-7-8-leggings-pockets'||handle==='pregnancy-recovery-emama-shorts-pockets')return 'pp';
    return 't2';
  }

  // Kit quantities per stage group: [P0,P1,P2,P3,P4,P5,P6,P7,P8]
  var STAGE_KIT_QTY={
    pregnancy:{
      single:     [1,0,0,0,0,0,0,0,0],
      essentials: [1,1,1,1,1,0,0,0,0],
      prepared:   [2,1,1,2,1,0,0,0,0],
      ultimate:   [2,2,2,2,1,0,0,0,0],
    },
    postpartum:{
      single:     [0,0,0,1,0,0,0,0,0],
      essentials: [0,1,0,2,2,0,0,0,0],
      prepared:   [0,2,0,2,2,1,0,0,0],
      ultimate:   [0,2,0,2,2,1,2,0,0],
    },
    mumlife:{
      single:     [0,0,0,0,0,0,1,0,0],
      essentials: [0,0,0,0,0,2,1,1,1],
      prepared:   [0,0,0,0,0,2,2,1,2],
      ultimate:   [0,0,0,0,0,3,2,2,2],
    }
  };
  var KIT_ITEMS={single:1,essentials:5,prepared:7,ultimate:9};

  // Kit names per stage group
  var STAGE_KIT_NAMES={
    pregnancy:{single:'Just the Maternity Leggings',essentials:'Maternity Essentials',prepared:'Complete Maternity Set',ultimate:'Hospital Bag + Beyond Set'},
    postpartum:{single:'Just the Recovery Leggings',essentials:'Recovery Essentials',prepared:'Complete Recovery Set',ultimate:'Fourth Trimester Sorted Set'},
    mumlife:{single:'Just the Shaper Move Leggings',essentials:MUM_CAP+' Life Essentials',prepared:'Complete '+MUM_CAP+' Life Set',ultimate:'Week Sorted Set'}
  };

  // Kit labels, proof, and CTA copy per stage group
  var STAGE_KIT_META={
    pregnancy:{
      single:{label:'Just the Maternity Leggings',copy:'Shop this piece on its own',cta:'Add to Cart'},
      essentials:{label:'Maternity Essentials',copy:'Most mums start here',proofMode:'save_vs_rrp',cta:'Add Essentials Set'},
      prepared:{label:'Complete Maternity Set',copy:'Most popular comes with free shipping',proofMode:'free_shipping',cta:'Add Complete Set'},
      ultimate:{label:'Hospital Bag + Beyond Set',copy:'Best value per item',proofMode:'delta_from_prepared',cta:'Add Best Value Set'}
    },
    postpartum:{
      single:{label:'Just the Recovery Leggings',copy:'Shop this piece on its own',cta:'Add to Cart'},
      essentials:{label:'Recovery Essentials',copy:'Start with the recovery must-haves',proofMode:'save_vs_rrp',cta:'Add Essentials Set'},
      prepared:{label:'Complete Recovery Set',copy:'Most popular comes with free shipping',proofMode:'free_shipping',cta:'Add Complete Set'},
      ultimate:{label:'Fourth Trimester Sorted Set',copy:'Best value per item',proofMode:'delta_from_prepared',cta:'Add Best Value Set'}
    },
    mumlife:{
      single:{label:'Just the Shaper Move Leggings',copy:'Shop this piece on its own',cta:'Add to Cart'},
      essentials:{label:MUM_CAP+' Life Essentials',copy:'Start with the everyday must-haves',proofMode:'save_vs_rrp',cta:'Add Essentials Set'},
      prepared:{label:'Complete '+MUM_CAP+' Life Set',copy:'Most popular comes with free shipping',proofMode:'free_shipping',cta:'Add Complete Set'},
      ultimate:{label:'Week Sorted Set',copy:'Best value per item',proofMode:'delta_from_prepared',cta:'Add Best Value Set'}
    }
  };

  // Social proof numbers per stage group
  var STAGE_SOCIAL={
    pregnancy:{single:'524',essentials:'3,927',prepared:'8,354',ultimate:'1,744'},
    postpartum:{single:'891',essentials:'1,843',prepared:'4,218',ultimate:'892'},
    mumlife:{single:'437',essentials:'1,254',prepared:'2,876',ultimate:'631'}
  };

  // Hero text per stage group
  var STAGE_HERO={
    pregnancy:{
      title:'Feel comfortable again \u2014 without buying everything separately',
      sub:'One set. Everything you actually need for pregnancy comfort.'
    },
    postpartum:{
      title:'Your body just did something incredible \u2014 give it what it needs',
      sub:'Recovery leggings, nursing crops and compression pieces designed for post-birth healing.'
    },
    mumlife:{
      title:'Look good. Feel held. Skip the '+MUM+'-tum anxiety.',
      sub:'Shapewear that actually works \u2014 designed by '+MUMS+', for '+MUMS+'.'
    }
  };

  // Product display info per stage group
  var STAGE_PRODUCTS={
    pregnancy:{
      groups:[
        {label:'For pregnancy',items:[
          {idx:0,name:'7/8 Maternity Leggings + Pockets',desc:'Grows with your bump through every trimester'},
          {idx:2,name:'Maternity Shorts + Pockets',desc:'For warmer days and lighter workouts'},
          {idx:1,name:'Nursing Crop',desc:'Supports you now, easy-access for feeding later'}
        ]},
        {label:'For recovery',items:[
          {idx:3,name:'7/8 Recovery Leggings + Pockets',desc:'Gentle compression for post-birth healing'},
          {idx:4,name:'Recovery Shorts + Pockets',desc:'Comfortable support as you ease back in'}
        ]}
      ]
    },
    postpartum:{
      groups:[
        {label:'For feeding',items:[
          {idx:1,name:'Nursing Crop',desc:'Supports you now, easy-access for feeding later'}
        ]},
        {label:'For recovery',items:[
          {idx:3,name:'7/8 Recovery Leggings + Pockets',desc:'Gentle compression for post-birth healing'},
          {idx:4,name:'Recovery Shorts + Pockets',desc:'Comfortable support as you ease back in'}
        ]},
        {label:'For getting back to you',items:[
          {idx:5,name:'Shaper Move Shorts + Pockets',desc:'Smooths and shapes without squeezing'},
          {idx:6,name:'7/8 Shaper Move Leggings + Pockets',desc:MUM_CAP+'-tum hiding activewear you can wear anywhere'}
        ]}
      ]
    },
    mumlife:{
      groups:[
        {label:'For your everyday',items:[
          {idx:7,name:'Long Line Crop',desc:'All-day support that looks great under anything'},
          {idx:8,name:'Body Shapewear Shorts + Pockets',desc:'Holds you in comfortably all day'},
          {idx:5,name:'Shaper Move Shorts + Pockets',desc:'Smooths and shapes without squeezing'},
          {idx:6,name:'7/8 Shaper Move Leggings + Pockets',desc:MUM_CAP+'-tum hiding activewear you can wear anywhere'}
        ]}
      ]
    }
  };

  // Pricing: loaded from the same cart-bundle-config.json the discount function uses
  var S='$',tierPrice=35; // defaults until config loads
  var stageGroup='pregnancy';
  var KITS={}; // rebuilt by rebuildKits()
  var lastStandardKit=PDP_HANDLE?'single':'prepared';
  var customBaseQty=null;

  function rebuildKits(){
    stageGroup=getStageGroup(tri);
    var qty=STAGE_KIT_QTY[stageGroup];
    var names=STAGE_KIT_NAMES[stageGroup];
    var meta=STAGE_KIT_META[stageGroup]||STAGE_KIT_META.pregnancy;
    KITS={};
    for(var k in KIT_ITEMS){
      KITS[k]={price:Math.round(tierPrice*KIT_ITEMS[k]),label:names[k],ctaLabel:meta[k]&&meta[k].cta?meta[k].cta:'Add to Cart',qty:qty[k].slice(),totalItems:KIT_ITEMS[k]};
    }
    // Recompute from tier pricing if available
    if(window._mesPriceForQty){
      for(var k in KIT_ITEMS){
        KITS[k].price=Math.round(window._mesPriceForQty(KIT_ITEMS[k])*KIT_ITEMS[k]);
      }
    }
  }

  function cloneQtyArray(arr){
    return (arr||[]).slice();
  }

  function sumQtyArray(arr){
    var total=0;
    (arr||[]).forEach(function(q){total+=q||0;});
    return total;
  }

  function arraysEqual(a,b){
    if((a||[]).length!==(b||[]).length)return false;
    for(var i=0;i<(a||[]).length;i++){
      if((a[i]||0)!==(b[i]||0))return false;
    }
    return true;
  }

  function getStandardKitKeys(){
    return PDP_HANDLE?['single','essentials','prepared','ultimate']:['essentials','prepared','ultimate'];
  }

  function getFallbackStandardKit(){
    if(PDP_HANDLE&&lastStandardKit==='single')return 'single';
    return lastStandardKit||'prepared';
  }

  function getKitQtyForKey(key){
    return KITS[key]&&KITS[key].qty?cloneQtyArray(KITS[key].qty):[];
  }

  function getActiveBaseQty(){
    if(kit==='custom'){
      if(customBaseQty)return cloneQtyArray(customBaseQty);
      return getKitQtyForKey(getFallbackStandardKit());
    }
    return getKitQtyForKey(kit);
  }

  function getBaseItemCount(){
    return sumQtyArray(getActiveBaseQty());
  }

  function getTierUnitPrice(count){
    return window._mesPriceForQty?window._mesPriceForQty(Math.max(count,1)):35;
  }

  function getPdpSingleBundleButtonPrice(){
    if(!PDP_HANDLE)return null;
    var singleButton=document.querySelector('#bundle-buttons button[data-bundle="1"]');
    if(!singleButton)return null;
    var raw=singleButton.getAttribute('data-price')||'';
    var normalized=String(raw).replace(/[^0-9.]/g,'');
    if(normalized)return Math.ceil(Number(normalized));
    var priceNode=singleButton.querySelector('span:last-child');
    var text=priceNode&&priceNode.textContent?String(priceNode.textContent):'';
    var match=text.match(/([0-9]+(?:\.[0-9]+)?)/);
    return match?Math.ceil(Number(match[1])):null;
  }

  function getTierTotalPrice(count){
    return Math.round(getTierUnitPrice(count)*Math.max(count,1));
  }

  function getCurrentTotalPrice(){
    var totalCount=getTotalItemCount();
    if(kit==='single'&&totalCount===1)return getPdpSinglePrice();
    return getTierTotalPrice(totalCount);
  }

  function getCurrentNormalPrice(){
    var total=0;
    var activeQty=getActiveBaseQty();
    activeQty.forEach(function(q,i){total+=q*(RRP_PER[i]||0);});
    customItems.forEach(function(ci){total+=ci.rrp*ci.qty;});
    return total;
  }

  function detectMatchingStandardKit(qty){
    var keys=getStandardKitKeys();
    for(var i=0;i<keys.length;i++){
      var key=keys[i];
      if(arraysEqual(qty,getKitQtyForKey(key)))return key;
    }
    return null;
  }

  function hasCustomPackState(){
    return !!customBaseQty||customItems.length>0;
  }

  function getCustomPackStageLabel(){
    if(stageGroup==='postpartum')return 'Postpartum';
    if(stageGroup==='mumlife')return MUM_CAP;
    return 'Maternity';
  }

  function getCurrentPackTitle(){
    if(kit==='custom')return 'Your Custom '+getCustomPackStageLabel()+' Set';
    return (STAGE_KIT_NAMES[stageGroup]&&STAGE_KIT_NAMES[stageGroup][kit])||(KITS[kit]&&KITS[kit].label)||(''+getTotalItemCount()+' item set');
  }

  function fmtMoney(amount){
    return S+Math.ceil(Number(amount)||0);
  }

  function getStageKitMeta(group){
    return STAGE_KIT_META[group]||STAGE_KIT_META.pregnancy;
  }

  function getKitProofText(key, meta, pricing){
    if(!meta)return '';
    if(meta.proofMode==='save_vs_rrp')return 'save '+fmtMoney(pricing[key+'Save']);
    if(meta.proofMode==='free_shipping')return 'free shipping included';
    if(meta.proofMode==='delta_from_prepared')return 'only '+fmtMoney(pricing.ultimateDelta)+' more';
    if(meta.proofMode==='delta_from_essentials')return 'only '+fmtMoney(pricing.preparedDelta)+' more';
    return meta.proof||'';
  }

  function renderKitPickerCopy(group){
    var meta=getStageKitMeta(group||stageGroup);
    var essRrp=0,prepRrp=0,ultRrp=0;
    KITS.essentials.qty.forEach(function(q,i){essRrp+=q*RRP_PER[i];});
    KITS.prepared.qty.forEach(function(q,i){prepRrp+=q*RRP_PER[i];});
    KITS.ultimate.qty.forEach(function(q,i){ultRrp+=q*RRP_PER[i];});
    var pricing={
      essentialsSave:Math.max(0,essRrp-KITS.essentials.price),
      preparedSave:Math.max(0,prepRrp-KITS.prepared.price),
      ultimateSave:Math.max(0,ultRrp-KITS.ultimate.price),
      preparedDelta:Math.max(0,KITS.prepared.price-KITS.essentials.price),
      ultimateDelta:Math.max(0,KITS.ultimate.price-KITS.prepared.price)
    };

    ['essentials','prepared','ultimate'].forEach(function(key){
      var labelEl=document.getElementById('kit-label-'+key);
      if(labelEl)labelEl.textContent=meta[key].label;
      var subEl=document.getElementById('kit-sub-'+key);
      if(subEl)subEl.textContent=meta[key].copy;
      var saveChipEl=document.getElementById('kit-save-chip-'+key);
      if(saveChipEl)saveChipEl.textContent=getKitProofText(key,meta[key],pricing);
    });

    var singleLabel=document.getElementById('kit-single-label');
    if(singleLabel&&!PDP_HANDLE)singleLabel.textContent=meta.single.label;
    var singleCopy=document.getElementById('kit-copy-single');
    if(singleCopy)singleCopy.textContent=meta.single.copy;
  }

  function getSaleOfferSummary(){
    if(!KITS.essentials||!KITS.prepared||!KITS.ultimate)return '';
    return '5 for '+fmtMoney(KITS.essentials.price)+' • 7 for '+fmtMoney(KITS.prepared.price)+' • 9 for '+fmtMoney(KITS.ultimate.price);
  }

  function getSelectedPackUrgency(activeSale){
    var meta=getStageKitMeta(stageGroup);
    if(!activeSale){
      return {eyebrow:'',main:'',sub:''};
    }

    if(kit==='custom'){
      return {
        eyebrow:'Flash sale pick',
        main:getCurrentPackTitle()+' selected — '+fmtMoney(getCurrentTotalPrice()),
        sub:'Customise your set now and lock in the live flash-sale pricing before the timer ends.'
      };
    }

    if(kit==='single'){
      return {
        eyebrow:'Flash sale live',
        main:'Most '+MUMS+' switch to '+meta.essentials.label+' for the first bundle discount.',
        sub:'Get 5 items for '+fmtMoney(KITS.essentials.price)+' before the timer ends.'
      };
    }

    if(kit==='essentials'){
      return {
        eyebrow:'Flash sale pick',
        main:meta.essentials.label+' selected — '+fmtMoney(KITS.essentials.price),
        sub:'Upgrade to '+meta.prepared.label+' for just '+fmtMoney(KITS.prepared.price-KITS.essentials.price)+' more and get free shipping.'
      };
    }

    if(kit==='prepared'){
      return {
        eyebrow:'Most popular today',
        main:meta.prepared.label+' selected — '+fmtMoney(KITS.prepared.price),
        sub:'Upgrade to '+meta.ultimate.label+' for just '+fmtMoney(KITS.ultimate.price-KITS.prepared.price)+' more.'
      };
    }

    return {
      eyebrow:'Best value selected',
      main:meta.ultimate.label+' selected — '+fmtMoney(KITS.ultimate.price),
      sub:'Your best flash-sale value per item is locked in while the timer runs.'
    };
  }

  function renderFlashSaleBuilderUI(){
    var strip=document.getElementById('mes-sale-strip');
    var countdown=document.getElementById('mes-sale-countdown');
    var offers=document.getElementById('mes-sale-offers');
    var urgency=document.getElementById('mes-kit-urgency');
    var urgencyEyebrow=document.getElementById('mes-kit-urgency-eyebrow');
    var urgencyMain=document.getElementById('mes-kit-urgency-main');
    var urgencySub=document.getElementById('mes-kit-urgency-sub');
    if(!strip||!countdown||!offers||!urgency||!urgencyEyebrow||!urgencyMain||!urgencySub)return;

    var flashSale=getFlashSaleApi();
    var saleState=getFlashSaleState();
    var hasSaleKits=!!(KITS&&KITS.essentials&&KITS.prepared&&KITS.ultimate);
    if(!saleState.active||!flashSale||!hasSaleKits){
      strip.style.display='none';
      urgency.style.display='none';
      return;
    }

    strip.style.display='block';
    urgency.style.display='block';
    countdown.textContent=flashSale.formatCountdown(saleState.remainingMs);
    offers.textContent=getSaleOfferSummary();

    var urgencyCopy=getSelectedPackUrgency(true);
    urgencyEyebrow.textContent=urgencyCopy.eyebrow;
    urgencyMain.textContent=urgencyCopy.main;
    urgencySub.textContent=urgencyCopy.sub;
  }

  function getCurrentPackMeta(){
    if(kit!=='custom')return '';
    var total=getTotalItemCount();
    if(total<5)return 'smaller set built by you';
    if(total>9)return 'expanded set built by you';
    return 'customised by you';
  }

  function getPdpStageDescriptor(){
    if(stageGroup==='postpartum')return 'postpartum';
    if(stageGroup==='mumlife')return MUM;
    return 'maternity';
  }

  function getStickyPackBuilderLabel(){
    return 'get this in our '+getPdpStageDescriptor()+' set at a cheaper price';
  }

  function isPdpIncludedInPreparedPack(){
    if(!PDP_HANDLE)return false;
    var idx=HANDLE_TO_IDX[PDP_HANDLE];
    if(idx===undefined)return false;
    var preparedQty=getKitQtyForKey('prepared');
    return (preparedQty[idx]||0)>0;
  }

  function isPdpIncludedInCurrentSelection(){
    if(!PDP_HANDLE)return false;
    var idx=HANDLE_TO_IDX[PDP_HANDLE];
    if(idx!==undefined){
      var activeQty=getActiveBaseQty();
      if((activeQty[idx]||0)>0)return true;
    }
    for(var i=0;i<customItems.length;i++){
      if(customItems[i].handle===PDP_HANDLE)return true;
    }
    return false;
  }

  function updatePdpEntryContent(){
    if(!PDP_HANDLE)return;
    var scrollTarget=document.getElementById('mes-scroll-target');
    var line1=document.getElementById('mes-pdp-entry-line1');
    var line2=document.getElementById('mes-pdp-entry-line2');
    var caption=document.getElementById('mes-pdp-entry-caption');
    var heroPrice=document.getElementById('mes-set-price');
    var heroRrp=document.getElementById('mes-set-rrp');
    if(scrollTarget)scrollTarget.style.display='none';
    if(line1)line1.textContent='';
    if(line2)line2.textContent='';
    if(caption)caption.textContent='';
    if(heroPrice)heroPrice.textContent='';
    if(heroRrp)heroRrp.textContent='';
    return;

    var productName=PDP_NAME||'this product';
    var stageDescriptor=getPdpStageDescriptor();
    var totalCount=getTotalItemCount()||KIT_ITEMS.prepared;
    var totalPrice=getCurrentTotalPrice()||getTierTotalPrice(KIT_ITEMS.prepared);
    var totalRrp=getCurrentNormalPrice();
    var preparedIncluded=isPdpIncludedInPreparedPack();
    var currentIncluded=isPdpIncludedInCurrentSelection();
    var customFlow=(pendingPdpCustomSeed||hasCustomPackState()||!preparedIncluded);

    heroPrice.textContent=S+totalPrice;
    heroRrp.textContent=totalRrp>totalPrice?'normally '+S+totalRrp:'';

    if(kit==='single'&&!customItems.length){
      line1.textContent='Get just the '+productName;
      line2.textContent='single item price';
      caption.textContent='or build your full set below';
      heroRrp.textContent='';
      return;
    }

    if(customFlow&&!currentIncluded){
      line1.textContent='Add the '+productName+' to your custom '+stageDescriptor+' set';
      line2.textContent='starts with '+KIT_ITEMS.prepared+' items and includes this product once you choose your size';
      caption.textContent='pick below to build your custom set';
      return;
    }

    if(customFlow){
      line1.textContent='Your custom '+stageDescriptor+' set includes '+productName;
      line2.textContent=totalCount+' items built around this product for';
      caption.textContent='adjust below to keep or swap what goes in your set';
      return;
    }

    line1.textContent='Get the '+productName+' in our '+getCurrentPackTitle().toLowerCase();
    line2.textContent=totalCount+' items built for '+stageDescriptor+' for';
    caption.textContent='pick below to see your perfect set';
  }

  function getActiveSocialKey(){
    if(kit!=='custom')return kit;
    var total=getTotalItemCount();
    if(total<=5)return 'essentials';
    if(total<=7)return 'prepared';
    return 'ultimate';
  }

  function syncCustomPackOption(){
    var show=hasCustomPackState();
    var selectorBtn=document.querySelector('#variant-selector button[data-kit="custom"]');
    var stickyBtn=document.querySelector('#sticky-set-options button[data-sticky-kit="custom"]');
    if(PDP_HANDLE){
      if(selectorBtn)selectorBtn.style.display='none';
      if(stickyBtn)stickyBtn.style.display='none';
      return;
    }
    if(selectorBtn)selectorBtn.style.display=show?'':'none';
    if(stickyBtn)stickyBtn.style.display=show?'':'none';
    if(!show)return;
    var totalCount=getTotalItemCount();
    var totalPrice=getCurrentTotalPrice();
    var totalRrp=getCurrentNormalPrice();
    var saved=Math.max(0,totalRrp-totalPrice);
    var title=getCurrentPackTitle();
    var meta=getCurrentPackMeta();
    var ids={
      title:['kit-custom-label','sticky-title-custom'],
      count:['kit-count-custom','sticky-qty-custom'],
      meta:['kit-sub-custom','sticky-meta-custom'],
      price:['price-custom','kit-today-custom','sticky-price-custom'],
      rrp:['kit-rrp-custom'],
      save:['kit-save-chip-custom']
    };
    ids.title.forEach(function(id){var el=document.getElementById(id);if(el)el.textContent=title;});
    ids.count.forEach(function(id){var el=document.getElementById(id);if(el)el.textContent=totalCount+' items';});
    ids.meta.forEach(function(id){var el=document.getElementById(id);if(el)el.textContent=meta;});
    ids.price.forEach(function(id){var el=document.getElementById(id);if(el)el.textContent=S+totalPrice;});
    ids.rrp.forEach(function(id){var el=document.getElementById(id);if(el)el.textContent='normally '+S+totalRrp;});
    ids.save.forEach(function(id){var el=document.getElementById(id);if(el)el.textContent='save '+S+saved;});
  }

  function refreshKitSelectionUi(){
    var activeKey=hasCustomPackState()?'custom':kit;
    document.querySelectorAll('#variant-selector button[data-kit]').forEach(function(b){
      b.classList.toggle('mes-kit-active',b.getAttribute('data-kit')===activeKey);
    });
    document.querySelectorAll('[data-sticky-kit]').forEach(function(b){
      b.classList.toggle('is-active',b.getAttribute('data-sticky-kit')===activeKey);
    });
  }

  function syncPackState(){
    if(customBaseQty){
      var matched=detectMatchingStandardKit(customBaseQty);
      if(matched&&!customItems.length){
        customBaseQty=null;
        kit=matched;
        lastStandardKit=matched;
      }else{
        kit='custom';
      }
    }else if(customItems.length){
      kit='custom';
    }else if(kit==='custom'){
      kit=getFallbackStandardKit();
    }
    syncCustomPackOption();
    refreshKitSelectionUi();
  }

  function refreshPackUi(){
    syncPackState();
    renderProductList();
    renderCustomItems();
    updQtyBadges();
    updSavings();
    updAtc();
    renderFlashSaleBuilderUI();
    renderHeroCarousel();
  }

  // Fetch real pricing from bundle config
  if(cfg.BUNDLE_CONFIG_URL){
    fetch(cfg.BUNDLE_CONFIG_URL).then(function(r){return r.json();}).then(function(allCfg){
      var cc=allCfg[CURRENCY]||allCfg.AUD||{};
      var tiers=(cc.tiers||[]).sort(function(a,b){return a.min_qty-b.min_qty;});
      if(CURRENCY==='GBP')S='\u00A3';else if(CURRENCY==='EUR')S='\u20AC';else if(CURRENCY==='SGD')S='S$';else S='$';

      function priceForQty(qty){
        var p=tiers[0]?tiers[0].price:35;
        for(var i=0;i<tiers.length;i++){if(qty>=tiers[i].min_qty)p=tiers[i].price;}
        return p;
      }
      window._mesPriceForQty=priceForQty;
      tierPrice=priceForQty(1);

      // Rebuild kits with real pricing and refresh UI
      rebuildKits();
      renderStageUI();

      // Init product resolver preorder config
      if(window.EmmacoProductResolver&&cfg.PREORDER_CONFIG_URL){
        window.EmmacoProductResolver.loadPreorderConfig(cfg.PREORDER_CONFIG_URL);
      }
    }).catch(function(){});
  }

  // ── Custom items (non-set products added by user) ──
  var customItems=[]; // [{handle,name,variantId,qty,rrp}]
  var productCache={}; // handle -> {title,image,variants:[{id,title,available,price,compareAtPrice}]}

  function findBestVariant(prod,userSz){
    if(!prod||!prod.variants||!prod.variants.length)return null;
    for(var i=0;i<prod.variants.length;i++){
      if(prod.variants[i].title.toUpperCase()===userSz&&prod.variants[i].available)return prod.variants[i];
    }
    for(var j=0;j<prod.variants.length;j++){
      if(prod.variants[j].available)return prod.variants[j];
    }
    return prod.variants[0]||null;
  }

  function formatNormallyLine(total){
    if(!(total>0))return '';
    return '<div style="font-size:11px;color:#9ca3af;margin-top:3px;line-height:1.3;">normally '+S+Math.ceil(total)+'</div>';
  }

  function getKnownHandleRrp(handle){
    var idx=HANDLE_TO_IDX[handle];
    if(idx===undefined)return null;
    return RRP_PER[idx]||null;
  }

  function getNormalPriceForHandle(handle,qty){
    var unit=getKnownHandleRrp(handle);
    if(unit===null&&productCache[handle]){
      var variant=findBestVariant(productCache[handle],(sz||'M').toUpperCase());
      if(variant)unit=Math.round((variant.compareAtPrice||variant.price||0)/100);
    }
    return unit?unit*(qty||1):null;
  }

  function hydrateNormalPriceLines(container){
    if(!container)return;
    container.querySelectorAll('[data-mes-normal-price-handle]').forEach(function(el){
      var handle=el.getAttribute('data-mes-normal-price-handle');
      var qty=parseInt(el.getAttribute('data-mes-normal-price-qty')||'1',10)||1;
      var known=getNormalPriceForHandle(handle,qty);
      if(known){
        el.textContent='normally '+S+Math.ceil(known);
        el.style.display='block';
        return;
      }
      fetchProduct(handle).then(function(prod){
        var variant=findBestVariant(prod,(sz||'M').toUpperCase());
        var unit=variant?Math.round((variant.compareAtPrice||variant.price||0)/100):0;
        if(unit>0){
          el.textContent='normally '+S+Math.ceil(unit*qty);
          el.style.display='block';
        }
      }).catch(function(){});
    });
  }

  // Per-badge availability check: looks up the EXACT-size variant for each handle. If Shopify
  // reports variant.available === false (i.e. inventory_quantity < 1 AND inventory_policy ===
  // 'deny' — accounting for "continue selling when out of stock"), swap badge to "sold out
  // this batch" and the click handler skips. .available === true means either inventory > 0
  // OR the variant has continue-selling enabled, so the user can still add it.
  function hydrateAvailability(container){
    if(!container)return;
    container.querySelectorAll('.mes-add-item[data-handle]').forEach(function(badge){
      if(badge.__availChecked)return;
      badge.__availChecked=true;
      var handle=badge.getAttribute('data-handle');
      var size=(badge.getAttribute('data-size')||sz||'M').toUpperCase();
      fetchProduct(handle).then(function(prod){
        if(!prod||!prod.variants)return;
        var exact=null;
        for(var i=0;i<prod.variants.length;i++){
          if((prod.variants[i].title||'').trim().toUpperCase()===size){exact=prod.variants[i];break;}
        }
        if(!exact||!exact.available){
          badge.classList.add('mes-sold-out');
          badge.textContent='sold out this batch';
          badge.style.background='#6b7280';
          badge.style.cursor='default';
          badge.style.opacity='0.85';
        }
      }).catch(function(){});
    });
  }

  function fetchProduct(handle){
    if(productCache[handle])return Promise.resolve(productCache[handle]);
    return fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(d){
      var prod={title:d.title,image:d.featured_image,variants:d.variants.map(function(v){return{id:v.id,title:v.title,available:v.available,price:v.price,compareAtPrice:v.compare_at_price||0};})};
      productCache[handle]=prod;
      return prod;
    }).catch(function(){return null;});
  }

  function getCustomTotalQty(){
    var q=0;customItems.forEach(function(ci){q+=ci.qty;});return q;
  }

  function getTotalItemCount(){
    return getBaseItemCount()+getCustomTotalQty();
  }

  function getCustomItemPrice(){
    return getTierUnitPrice(getTotalItemCount());
  }

  function addCustomItem(handle,name,rrp){
    if(PDP_HANDLE)enterPackBuilderMode();
    if(HANDLE_TO_IDX[handle]!==undefined){
      adjustBaseItemQty(handle,1);
      return;
    }
    for(var i=0;i<customItems.length;i++){
      if(customItems[i].handle===handle){
        customItems[i].qty+=1;
        refreshPackUi();
        return;
      }
    }
    var userSz=(sz||'M').toUpperCase();
    fetchProduct(handle).then(function(prod){
      if(!prod)return;
      // Find variant matching user's size
      var variant=findBestVariant(prod,userSz);
      if(!variant)return;
      var compareAt=Math.round(((variant.compareAtPrice||0)||variant.price||0)/100);
      customItems.push({handle:handle,name:name||prod.title,variantId:variant.id,qty:1,rrp:compareAt||rrp||Math.round(variant.price/100),img:prod.image||''});
      refreshPackUi();
    });
  }

  function renderCustomItems(){
    // Render into the visible "You also added" section under kit selector
    var container=document.getElementById('mes-custom-added');
    if(!container)return;
    if(!customItems.length){container.style.display='none';container.innerHTML='';return;}
    container.style.display='block';
    var h='<div style="font-size:13px;font-weight:400;color:#6b7280;letter-spacing:0.04em;margin:0 0 8px 0;">you also added:</div>';
    customItems.forEach(function(ci,idx){
      h+='<div style="display:flex;align-items:center;justify-content:space-between;padding:6px 0;">';
      h+='<span style="font-size:14px;font-weight:600;color:#1f2937;letter-spacing:0.02em;">x'+ci.qty+' '+ci.name+'</span>';
      h+='<span style="display:flex;align-items:center;gap:6px;">';
      h+='<span style="font-size:14px;font-weight:700;color:#1f2937;">'+S+Math.ceil(getTierUnitPrice(getTotalItemCount())*ci.qty)+'</span>';
      h+='<button data-ci-minus="'+idx+'" type="button" style="font-size:11px;color:#9ca3af;background:none;border:none;cursor:pointer;padding:2px 4px;">remove</button>';
      h+='</span></div>';
    });
    container.innerHTML=h;
    // Wire remove buttons
    container.querySelectorAll('[data-ci-minus]').forEach(function(b){
      b.addEventListener('click',function(){
        var i=parseInt(b.getAttribute('data-ci-minus'));
        customItems.splice(i,1);
        refreshPackUi();
      });
    });
  }

  // Product name map (all 9)
  var PRODUCT_NAME_MAP={
    '7-8-mat-pocket-leggings-black':'7/8 Maternity Leggings + Pockets',
    'emama-longline-crop':'Nursing Crop',
    'shorts-mat-pocket-black':'Maternity Shorts + Pockets',
    'pregnancy-recovery-emama-7-8-leggings-pockets':'7/8 Recovery Leggings + Pockets',
    'pregnancy-recovery-emama-shorts-pockets':'Recovery Shorts + Pockets',
    'shorts-shaper-move-pockets-black':'Shaper Move Shorts + Pockets',
    '7-8-shaper-move-leggings-pockets-black':'7/8 Shaper Move Leggings + Pockets',
    'long-line-crop-black':'Long Line Crop',
    'body-shapewear-shorts-pockets':'Body Shapewear Shorts + Pockets',
  };
  var STAGE_LABELS={t1:'in her 1st trimester',t2:'in her 2nd trimester',t3:'in her 3rd trimester',p:'post partum',k:'living her '+MUM+' life'};
  var kit=PDP_HANDLE?'single':'essentials',sz=null,tri=IS_HOME?null:getPdpInitialTri(PDP_HANDLE),allUgc=[];
  var resolvedProducts=null; // filled by resolver after size selection
  var stickySelectorOpen=false;
  var stickySaleTimerId=null;
  var pendingPdpCustomSeed=false;
  var pdpPackBuilderOpened=!PDP_HANDLE;
  var nativePdpSyncBound=false;
  var pdpSingleDefaultsApplied=false;
  var pdpSingleDefaultsStableCount=0;
  var pdpUserTouchedTopControls=false;
  var pdpQuantityObserver=null;
  var pdpSingleDefaultsTimer=null;
  var pdpSingleStickyTimer=null;
  var PDP_VARIANT_SIZE_BY_ID={};
  Object.keys(PDP_VARIANTS||{}).forEach(function(sizeKey){
    PDP_VARIANT_SIZE_BY_ID[String(PDP_VARIANTS[sizeKey])]=sizeKey;
  });

  function normalizePdpSize(value){
    var normalized=String(value||'').replace(/\s+/g,' ').trim().toUpperCase();
    if(!normalized)return null;
    var keys=Object.keys(PDP_VARIANTS||{});
    for(var i=0;i<keys.length;i++){
      if(keys[i].toUpperCase()===normalized)return keys[i];
    }
    return null;
  }

  function getPdpSinglePrice(){
    var bundlePrice=getPdpSingleBundleButtonPrice();
    if(bundlePrice!==null)return bundlePrice;
    return getTierTotalPrice(1);
  }

  function getPdpPageQuantity(){
    var quantityEl=document.getElementById('cart-qty');
    var quantityText=quantityEl&&quantityEl.textContent?String(quantityEl.textContent).trim():'';
    var parsedText=parseInt(quantityText,10);
    if(Number.isFinite(parsedText)&&parsedText>0)return parsedText;
    var quantityInput=document.querySelector('form[action*="/cart/add"] input[name="quantity"], .quantity-selector input[name="quantity"], input[name="quantity"]');
    var parsedInput=quantityInput?parseInt(String(quantityInput.value||'').trim(),10):NaN;
    if(Number.isFinite(parsedInput)&&parsedInput>0)return parsedInput;
    return 1;
  }

  function setPdpPageQuantity(quantity){
    var nextQty=Math.max(1,parseInt(quantity,10)||1);
    var quantityEl=document.getElementById('cart-qty');
    if(quantityEl)quantityEl.textContent=String(nextQty);
    document.querySelectorAll('form[action*="/cart/add"] input[name="quantity"], .quantity-selector input[name="quantity"], input[name="quantity"]').forEach(function(input){
      input.value=String(nextQty);
      input.dispatchEvent(new Event('input',{bubbles:true}));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
  }

  function getPdpBundleSelection(){
    if(!PDP_HANDLE)return null;
    var quantity=getPdpPageQuantity();
    var bestButton=null;
    var bestQty=0;
    document.querySelectorAll('#bundle-buttons button[data-bundle]').forEach(function(button){
      var packQty=parseInt(button.getAttribute('data-bundle')||'0',10);
      if(packQty<=quantity&&packQty>bestQty){
        bestButton=button;
        bestQty=packQty;
      }
    });
    var selectedButton=bestButton||document.querySelector('#bundle-buttons button.selected, #bundle-buttons button[aria-pressed="true"], #bundle-buttons button[data-bundle="1"]');
    if(!selectedButton)return null;
    var raw=selectedButton.getAttribute('data-price')||'';
    var normalized=String(raw).replace(/[^0-9.]/g,'');
    var unitPrice=normalized?Math.ceil(Number(normalized)):null;
    if(unitPrice===null){
      var priceNode=selectedButton.querySelector('span:last-child');
      var text=priceNode&&priceNode.textContent?String(priceNode.textContent):'';
      var match=text.match(/([0-9]+(?:\.[0-9]+)?)/);
      if(match)unitPrice=Math.ceil(Number(match[1]));
    }
    if(unitPrice===null)return null;
    return {
      quantity:quantity,
      unitPrice:unitPrice,
      totalPrice:Math.round(unitPrice*quantity)
    };
  }

  function getPdpSingleStateSummary(){
    var bundleSelection=getPdpBundleSelection();
    if(bundleSelection)return bundleSelection;
    var quantity=getPdpPageQuantity();
    var singlePrice=getPdpSinglePrice();
    return {
      quantity:quantity,
      unitPrice:singlePrice,
      totalPrice:Math.round(singlePrice*quantity)
    };
  }

  function ensurePdpSingleDefaults(){
    if(!PDP_HANDLE||pdpUserTouchedTopControls||!isPdpSingleMode())return true;
    var singleBundleButton=document.querySelector('#bundle-buttons button[data-bundle="1"]');
    if(singleBundleButton){
      var isActive=singleBundleButton.classList.contains('selected')||singleBundleButton.getAttribute('aria-pressed')==='true';
      if(!isActive)singleBundleButton.click();
      document.querySelectorAll('#bundle-buttons button[data-bundle]').forEach(function(button){
        var active=button===singleBundleButton;
        button.classList.toggle('selected',active);
        if(active)button.setAttribute('aria-pressed','true');
        else button.removeAttribute('aria-pressed');
      });
    }
    setPdpPageQuantity(1);
    pdpSingleDefaultsApplied=getPdpPageQuantity()===1&&(!singleBundleButton||singleBundleButton.classList.contains('selected')||singleBundleButton.getAttribute('aria-pressed')==='true');
    return pdpSingleDefaultsApplied;
  }

  function startPdpSingleStateSync(){
    if(!PDP_HANDLE)return;
    if(!pdpSingleStickyTimer){
      pdpSingleStickyTimer=window.setInterval(function(){
        if(isPdpSingleMode())updAtc();
      },200);
    }
    if(pdpSingleDefaultsTimer)return;
    pdpSingleDefaultsStableCount=0;
    pdpSingleDefaultsTimer=window.setInterval(function(){
      if(pdpUserTouchedTopControls||!isPdpSingleMode()){
        window.clearInterval(pdpSingleDefaultsTimer);
        pdpSingleDefaultsTimer=null;
        if(isPdpSingleMode())updAtc();
        return;
      }
      if(ensurePdpSingleDefaults()){
        pdpSingleDefaultsStableCount+=1;
      }else{
        pdpSingleDefaultsStableCount=0;
      }
      if(pdpSingleDefaultsStableCount>=10){
        window.clearInterval(pdpSingleDefaultsTimer);
        pdpSingleDefaultsTimer=null;
        if(isPdpSingleMode())updAtc();
      }
    },150);
    window.setTimeout(function(){
      if(pdpSingleDefaultsTimer){
        window.clearInterval(pdpSingleDefaultsTimer);
        pdpSingleDefaultsTimer=null;
      }
    },8000);
  }

  function getPdpSingleVariantId(sizeValue){
    var normalized=normalizePdpSize(sizeValue);
    if(!normalized)return null;
    return PDP_VARIANTS[normalized]||null;
  }

  function getNativePdpVariantInput(){
    return document.querySelector('form[action*="/cart/add"] [name="id"]');
  }

  function getPdpVariantData(){
    var jsonEl=document.getElementById('product-variants-json');
    if(!jsonEl||!jsonEl.textContent)return [];
    try{
      var parsed=JSON.parse(jsonEl.textContent);
      return Array.isArray(parsed)?parsed:[];
    }catch(error){
      return [];
    }
  }

  function getSelectedPdpSizeFromCustomButtons(){
    var selectedButton=document.querySelector('#size-buttons button.selected,[data-variant-id].selected');
    if(!selectedButton)return null;

    var variantId=selectedButton.getAttribute('data-variant-id');
    if(variantId&&PDP_VARIANT_SIZE_BY_ID[String(variantId)]){
      return PDP_VARIANT_SIZE_BY_ID[String(variantId)];
    }

    var variants=getPdpVariantData();
    for(var i=0;i<variants.length;i++){
      if(String(variants[i].id)===String(variantId)){
        return normalizePdpSize(variants[i].title);
      }
    }

    return normalizePdpSize(selectedButton.textContent);
  }

  function getSelectedPdpSizeFromForm(){
    if(!PDP_HANDLE)return null;
    var variantInput=getNativePdpVariantInput();
    var variantId=variantInput&&variantInput.value?String(variantInput.value):'';
    if(variantId&&PDP_VARIANT_SIZE_BY_ID[variantId])return PDP_VARIANT_SIZE_BY_ID[variantId];

    var customSize=getSelectedPdpSizeFromCustomButtons();
    if(customSize)return customSize;

    var checked=document.querySelectorAll('input[type="radio"]:checked, select option:checked');
    for(var i=0;i<checked.length;i++){
      var el=checked[i];
      var candidates=[el.value,el.getAttribute('data-value'),el.textContent];
      if(el.id){
        var label=document.querySelector('label[for="'+el.id+'"]');
        if(label)candidates.push(label.textContent);
      }
      for(var j=0;j<candidates.length;j++){
        var normalized=normalizePdpSize(candidates[j]);
        if(normalized)return normalized;
      }
    }
    return normalizePdpSize(sz);
  }

  function syncSizeFromNativePdpPicker(opts){
    if(!PDP_HANDLE)return null;
    var nativeSize=getSelectedPdpSizeFromForm();
    if(!nativeSize||nativeSize===sz)return nativeSize;
    sz=nativeSize;
    mkRow('sz-row',SIZES,sz,onBuilderSizePick);
    if(!opts||opts.refresh!==false){
      resolveCurrentSet();
      if(typeof renderSizeSummary==='function')renderSizeSummary();
      updAtc();
    }
    return nativeSize;
  }

  function applyPdpSizeToNativePicker(sizeValue){
    if(!PDP_HANDLE)return;
    var normalized=normalizePdpSize(sizeValue);
    if(!normalized)return;

    var customButtons=document.querySelectorAll('#size-buttons button,[data-variant-id]');
    var variantId=getPdpSingleVariantId(normalized);
    for(var customIndex=0;customIndex<customButtons.length;customIndex++){
      var customButton=customButtons[customIndex];
      var customVariantId=customButton.getAttribute('data-variant-id');
      if(customVariantId&&variantId&&String(customVariantId)===String(variantId)){
        customButton.click();
        break;
      }
    }

    var radios=document.querySelectorAll('input[type="radio"]');
    for(var i=0;i<radios.length;i++){
      var radio=radios[i];
      var radioCandidates=[radio.value,radio.getAttribute('data-value')];
      if(radio.id){
        var radioLabel=document.querySelector('label[for="'+radio.id+'"]');
        if(radioLabel)radioCandidates.push(radioLabel.textContent);
      }
      for(var j=0;j<radioCandidates.length;j++){
        if(normalizePdpSize(radioCandidates[j])===normalized){
          if(!radio.checked)radio.click();
          break;
        }
      }
    }
    document.querySelectorAll('select').forEach(function(selectEl){
      var matched=false;
      Array.prototype.forEach.call(selectEl.options||[],function(option){
        if(matched)return;
        if(normalizePdpSize(option.value)===normalized||normalizePdpSize(option.textContent)===normalized){
          selectEl.value=option.value;
          selectEl.dispatchEvent(new Event('change',{bubbles:true}));
          matched=true;
        }
      });
    });
    var variantInput=getNativePdpVariantInput();
    if(variantInput&&variantId){
      variantInput.value=String(variantId);
      variantInput.dispatchEvent(new Event('input',{bubbles:true}));
      variantInput.dispatchEvent(new Event('change',{bubbles:true}));
    }
  }

  function bindNativePdpPickerSync(){
    if(!PDP_HANDLE||nativePdpSyncBound)return;
    nativePdpSyncBound=true;
    document.addEventListener('change',function(event){
      var target=event.target;
      if(!target)return;
      if(target.closest('form[action*="/cart/add"]')||target.name==='id')syncSizeFromNativePdpPicker();
    },true);
    document.addEventListener('click',function(event){
      var target=event.target;
      if(!target||!target.closest)return;
      if(event.isTrusted&&target.closest('#bundle-buttons button[data-bundle], .quantity-selector button')){
        pdpUserTouchedTopControls=true;
      }
      if(target.closest('#size-buttons button,[data-variant-id]')){
        setTimeout(function(){
          syncSizeFromNativePdpPicker();
        },0);
      }
    },true);
    document.addEventListener('click',function(event){
      var target=event.target;
      if(!target||!target.closest)return;
      if(target.closest('#bundle-buttons button[data-bundle], .quantity-selector button, form[action*="/cart/add"] button')){
        setTimeout(function(){
          if(isPdpSingleMode())updAtc();
        },0);
      }
    },true);
    document.addEventListener('input',function(event){
      var target=event.target;
      if(event.isTrusted&&target&&target.matches&&target.matches('form[action*="/cart/add"] input[name="quantity"], .quantity-selector input[name="quantity"], input[name="quantity"]')){
        pdpUserTouchedTopControls=true;
      }
      if(target&&target.matches&&target.matches('form[action*="/cart/add"] input[name="quantity"], .quantity-selector input[name="quantity"], input[name="quantity"]')&&isPdpSingleMode()){
        setTimeout(updAtc,0);
      }
    },true);
    document.addEventListener('change',function(event){
      var target=event.target;
      if(event.isTrusted&&target&&target.matches&&target.matches('form[action*="/cart/add"] input[name="quantity"], .quantity-selector input[name="quantity"], input[name="quantity"]')){
        pdpUserTouchedTopControls=true;
      }
      if(target&&target.matches&&target.matches('form[action*="/cart/add"] input[name="quantity"], .quantity-selector input[name="quantity"], input[name="quantity"]')&&isPdpSingleMode()){
        setTimeout(updAtc,0);
      }
    },true);
    var quantityEl=document.getElementById('cart-qty');
    if(quantityEl&&!pdpQuantityObserver){
      pdpQuantityObserver=new MutationObserver(function(){
        if(!pdpUserTouchedTopControls&&isPdpSingleMode()&&getPdpPageQuantity()!==1)startPdpSingleStateSync();
        if(isPdpSingleMode())updAtc();
      });
      pdpQuantityObserver.observe(quantityEl,{childList:true,characterData:true,subtree:true});
    }
  }

  function isPdpSingleMode(){
    return !!(PDP_HANDLE&&!pdpPackBuilderOpened);
  }

  function revealPackBuilderForSelectedSize(){
    var setStep=document.getElementById('mes-step-set');
    if(setStep&&setStep.style.display==='none'){
      setStep.style.display='';
      setStep.classList.add('mes-fade-in');
    }
    collapseSz();
    var preSizeCta=document.getElementById('mes-pre-size-cta');
    if(preSizeCta)preSizeCta.style.display='none';
    var deskCta=document.getElementById('desk-pre-size-cta');
    if(deskCta)deskCta.style.display='none';
    var leftContent=document.getElementById('mes-left-content');
    if(leftContent&&leftContent.style.display==='none'){
      leftContent.style.display='';
      leftContent.classList.add('mes-fade-in');
    }
  }

  function enterPackBuilderMode(){
    if(!PDP_HANDLE||pdpPackBuilderOpened)return;
    pdpPackBuilderOpened=true;
    if(sz&&_userPickedSz)revealPackBuilderForSelectedSize();
    updAtc();
  }

  function setElementDisplay(id,show){
    var el=document.getElementById(id);
    if(el)el.style.display=show?'':'none';
  }

  function updateHomepageReveal(){
    if(!IS_HOME)return;
    var hasStage=!!tri;
    var hasSize=!!sz;
    setElementDisplay('mes-home-browse-wrap',!hasStage);
    setElementDisplay('mes-step-size',hasStage);
    setElementDisplay('mes-pre-size-cta',hasStage&&!hasSize);
    setElementDisplay('desk-pre-size-cta',hasStage&&!hasSize);
    setElementDisplay('mes-step-set',hasSize);
    setElementDisplay('mes-sale-strip',hasSize);
    setElementDisplay('mes-left-content',hasSize);
    if(!hasSize){
      var sizeExpanded=document.getElementById('sz-expanded');
      var sizeCollapsed=document.getElementById('sz-collapsed');
      if(sizeExpanded)sizeExpanded.style.display='';
      if(sizeCollapsed)sizeCollapsed.style.display='none';
    }
  }

  // ── Render full stage UI (product list, hero, kit labels, social numbers) ──
  function renderStageUI(){
    rebuildKits();
    var sg=stageGroup;
    var meta=getStageKitMeta(sg);

    // Hero text
    var heroTitle=document.getElementById('mes-hero-title');
    var heroSub=document.getElementById('mes-hero-sub');
    if(heroTitle)heroTitle.textContent=STAGE_HERO[sg].title;
    if(heroSub)heroSub.textContent=STAGE_HERO[sg].sub;

    // Stage headline above the hero carousel
    var stageForText={t1:'made for the 1st trimester',t2:'made for the 2nd trimester',t3:'made for the 3rd trimester',pp:'made for post partum '+MUMS,ml:'made for active '+MUMS};
    var forLine=stageForText[tri]||stageForText.t2;
    ['desk-stage-headline','mob-stage-headline'].forEach(function(id){
      var headline=document.getElementById(id);
      if(!headline)return;
      headline.innerHTML=''
        + '<div style="font-size:18px;font-weight:400;color:#1f2937;letter-spacing:0.08em;line-height:1.5;">your <span style="font-size:36px;font-weight:900;letter-spacing:0.06em;">perfect</span> set is here.</div>'
        + '<div style="font-size:18px;font-weight:400;color:#1f2937;letter-spacing:0.08em;line-height:1.5;margin-top:4px;">'+forLine+'</div>'
        + '<div style="font-size:14px;font-weight:300;color:#1f2937;letter-spacing:0.16em;line-height:1.4;text-transform:uppercase;margin-top:7px;">We built this pack just for you:</div>';
    });

    // UGC section headline (adaptive) — two lines
    var ugcLine1={t1:'from trimester 1',t2:'from trimester 2',t3:'from trimester 3',pp:'from post partum',ml:'from the everyday'};
    var ugcLine2={t1:'into '+MUM+' life',t2:'into '+MUM+' life',t3:'into '+MUM+' life',pp:'into '+MUM+' life',ml:'to the extraordinary'};
    var l1=ugcLine1[tri]||ugcLine1.t2;
    var l2=ugcLine2[tri]||ugcLine2.t2;
    ['desk','mob'].forEach(function(p){
      var e1=document.getElementById(p+'-ugc-stage-line');if(e1)e1.textContent=l1;
      var e2=document.getElementById(p+'-ugc-stage-line2');if(e2)e2.textContent=l2;
    });

    // Auto-fit text to container width
    requestAnimationFrame(function(){fitAllText();});

    // Product list
    renderProductList();

    renderKitPickerCopy(sg);

    // Kit selector labels + prices
    var names=STAGE_KIT_NAMES[sg];
    var kitBtns=document.querySelectorAll('#variant-selector button[data-kit]');
    kitBtns.forEach(function(btn){
      var k=btn.getAttribute('data-kit');
      if(k==='single'||!KITS[k])return; // handled separately below
      var priceEl=document.getElementById('price-'+k);
      if(priceEl)priceEl.textContent=S+KITS[k].price;
    });

    // Update save amounts
    var essRrp=0,prepRrp=0,ultRrp=0;
    KITS.essentials.qty.forEach(function(q,i){essRrp+=q*RRP_PER[i];});
    KITS.prepared.qty.forEach(function(q,i){prepRrp+=q*RRP_PER[i];});
    KITS.ultimate.qty.forEach(function(q,i){ultRrp+=q*RRP_PER[i];});
    [
      {key:'essentials',rrp:essRrp,price:KITS.essentials.price},
      {key:'prepared',rrp:prepRrp,price:KITS.prepared.price},
      {key:'ultimate',rrp:ultRrp,price:KITS.ultimate.price}
    ].forEach(function(entry){
      var todayEl=document.getElementById('kit-today-'+entry.key);
      if(todayEl)todayEl.textContent=S+entry.price;
      var rrpEl=document.getElementById('kit-rrp-'+entry.key);
      if(rrpEl)rrpEl.textContent='normally '+S+entry.rrp;
      var saveChipEl=document.getElementById('kit-save-chip-'+entry.key);
      if(saveChipEl)saveChipEl.textContent=getKitProofText(entry.key,meta[entry.key],{
        essentialsSave:Math.max(0,essRrp-KITS.essentials.price),
        preparedSave:Math.max(0,prepRrp-KITS.prepared.price),
        ultimateSave:Math.max(0,ultRrp-KITS.ultimate.price),
        preparedDelta:Math.max(0,KITS.prepared.price-KITS.essentials.price),
        ultimateDelta:Math.max(0,KITS.ultimate.price-KITS.prepared.price)
      });
    });

    var stickyNames={
      essentials:names.essentials,
      prepared:names.prepared,
      ultimate:names.ultimate
    };
    var stickyMeta={
      essentials:(document.getElementById('kit-sub-essentials')&&document.getElementById('kit-sub-essentials').textContent||'').replace(/\s+/g,' ').trim(),
      prepared:(document.getElementById('kit-sub-prepared')&&document.getElementById('kit-sub-prepared').textContent||'').replace(/\s+/g,' ').trim(),
      ultimate:(document.getElementById('kit-sub-ultimate')&&document.getElementById('kit-sub-ultimate').textContent||'').replace(/\s+/g,' ').trim()
    };
    Object.keys(stickyNames).forEach(function(key){
      var titleEl=document.getElementById('sticky-title-'+key);
      if(titleEl)titleEl.textContent=stickyNames[key];
      var metaEl=document.getElementById('sticky-meta-'+key);
      if(metaEl)metaEl.textContent=stickyMeta[key];
    });

    // Single item label — only overwrite on landing page (not PDP where Liquid sets product name)
    var singleLabel=document.getElementById('kit-single-label');
    if(singleLabel&&!PDP_HANDLE)singleLabel.textContent=names.single;
    var singleCopy=document.getElementById('kit-copy-single');
    if(singleCopy)singleCopy.textContent=meta.single.copy;
    // Single price: use the actual 1-item bundle price on PDP, else tier price
    var singlePrice=document.getElementById('price-single');
    var singleDisplayPrice=PDP_HANDLE?getPdpSinglePrice():KITS.single.price;
    if(singlePrice)singlePrice.textContent=S+singleDisplayPrice;

    updQtyBadges();
    updSavings();
    updAtc();
    updatePdpEntryContent();
    renderFlashSaleBuilderUI();
    if(typeof renderHeroCarousel==='function')renderHeroCarousel();
  }

  function renderProductList(){
    var sg=stageGroup;
    var productGroups=STAGE_PRODUCTS[sg].groups;
    var container=document.getElementById('mes-product-list');
    if(!container)return;

    // Build a map of resolved products by original handle for lookup
    var resolvedMap={};
    if(resolvedProducts){
      resolvedProducts.forEach(function(rp){
        resolvedMap[rp.originalHandle]=rp;
      });
    }

    var h='';
    productGroups.forEach(function(group){
      // Check if any items in this group are available
      var groupItems=group.items.filter(function(item){
        // If we have resolver data and the item couldn't be resolved, skip it
        if(resolvedProducts){
          var handles=getHandlesForIdx(item.idx);
          var anyResolved=handles.some(function(hh){return resolvedMap[hh];});
          if(!anyResolved)return false;
        }
        return true;
      });
      if(!groupItems.length)return;

      h+='<div style="margin:0 0 12px 0;">';
      h+='<div style="font-size:12px;font-weight:500;letter-spacing:0.06em;color:#3D9A8B;margin:0 0 8px 0;">'+group.label.toLowerCase()+'</div>';
      h+='<div style="display:flex;flex-direction:column;">';
      groupItems.forEach(function(item,i){
        var prod=P[item.idx];
        var img=prod&&prod.fi?prod.fi:'';
        var displayName=item.name;
        var note='';

        // Use resolved data if available
        var handles=getHandlesForIdx(item.idx);
        var resolved=null;
        for(var hi=0;hi<handles.length;hi++){if(resolvedMap[handles[hi]]){resolved=resolvedMap[handles[hi]];break;}}

        if(resolved){
          displayName=resolved.name;
          img=resolved.image||img;
          if(resolved.wasFallback)note='<div style="font-size:10px;color:#E8846C;margin-top:1px;">'+item.name+' unavailable in your size</div>';
        }

        h+='<div id="row-p'+item.idx+'" style="display:flex;align-items:center;gap:10px;padding:10px 0;border-bottom:1px solid #f3f4f6;">';
        if(img)h+='<img src="'+img+'" style="width:44px;height:44px;object-fit:cover;">';
        h+='<div style="flex:1;min-width:0;">';
        h+='<div style="font-size:14px;font-weight:600;letter-spacing:0.01em;">'+displayName+' <span id="qty-p'+item.idx+'" style="font-size:11px;color:#E8846C;font-weight:700;"></span></div>';
        h+='<div style="font-size:11px;color:#6b7280;margin-top:1px;">'+item.desc+'</div>';
        h+=note;
        h+='</div>';
        h+='<span style="font-size:13px;color:#9ca3af;text-decoration:line-through;flex-shrink:0;">'+S+RRP_PER[item.idx]+'</span>';
        h+='</div>';
      });
      h+='</div></div>';
    });
    container.innerHTML=h;
  }

  // Map product index to its primary handle(s) for resolver lookup
  var IDX_TO_HANDLE={
    0:'7-8-mat-pocket-leggings-black',
    1:'emama-longline-crop',
    2:'shorts-mat-pocket-black',
    3:'pregnancy-recovery-emama-7-8-leggings-pockets',
    4:'pregnancy-recovery-emama-shorts-pockets',
    5:'shorts-shaper-move-pockets-black',
    6:'7-8-shaper-move-leggings-pockets-black',
    7:'long-line-crop-black',
    8:'body-shapewear-shorts-pockets'
  };
  function getHandlesForIdx(idx){
    var h=IDX_TO_HANDLE[idx];
    return h?[h]:[];
  }
  var soundOn=false;
  function ru(u){if(!u)return'';return u.startsWith('http')?u:CDN+(u.startsWith('/')?'':'/')+u;}

  // ── Video visibility ──
  // Mobile: play one at a time. Desktop: play all visible.
  var _isDsk=window.matchMedia('(min-width:768px)').matches;
  var activeVideo=null;
  function setupVideoVisibility(){
    if(!('IntersectionObserver' in window))return;
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var vid=entry.target;
        if(entry.isIntersecting){
          if(!_isDsk){
            // Mobile: one at a time
            if(activeVideo&&activeVideo!==vid){try{activeVideo.pause();}catch(e){}}
            activeVideo=vid;
          }
          try{vid.play();}catch(e){}
        }else{
          try{vid.pause();}catch(e){}
          if(activeVideo===vid)activeVideo=null;
        }
      });
    },{threshold:0.5});
    document.querySelectorAll('video').forEach(function(v){
      if(!v.closest('#ugc-wall-grid'))obs.observe(v);
    });
    window._mesVideoObs=obs;
  }
  function observeNewVideos(container){
    if(!window._mesVideoObs)return;
    container.querySelectorAll('video').forEach(function(v){
      if(!v.closest('#ugc-wall-grid'))window._mesVideoObs.observe(v);
    });
    container.querySelectorAll('video').forEach(function(v){
      v.removeAttribute('autoplay');
      v.pause();
    });
  }

  // Sound toggle — tap unmutes that video, mutes all others
  function addSoundBtn(container){
    var videos=container.querySelectorAll('video');
    videos.forEach(function(vid){
      if(vid.parentElement.querySelector('.mes-sound-btn'))return;
      vid.muted=true;
      var btn=document.createElement('button');
      btn.className='mes-sound-btn';
      btn.type='button';
      btn.style.cssText='position:absolute;bottom:12px;right:12px;width:36px;height:36px;border-radius:50%;background:rgba(0,0,0,0.6);border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:5;';
      btn.innerHTML='\uD83D\uDD07';
      btn.addEventListener('click',function(e){
        e.stopPropagation();
        var wasMuted=vid.muted;
        // Mute all videos and reset all buttons
        document.querySelectorAll('video').forEach(function(v){v.muted=true;});
        document.querySelectorAll('.mes-sound-btn').forEach(function(b){b.innerHTML='\uD83D\uDD07';});
        // Toggle this one
        if(wasMuted){
          vid.muted=false;
          btn.innerHTML='\uD83D\uDD0A';
          soundOn=true;
        } else {
          soundOn=false;
        }
      });
      var wrapper=vid.parentElement;
      if(wrapper.style.position!=='relative'&&wrapper.style.position!=='absolute')wrapper.style.position='relative';
      wrapper.appendChild(btn);
    });
  }

  // ── Size buttons ──
  function mkRow(id,opts,cur,cb){
    var el=document.getElementById(id);el.innerHTML='';
    opts.forEach(function(o){
      var v=typeof o==='string'?o:o.v,l=typeof o==='string'?o:o.l,a=cur===v;
      var b=document.createElement('button');b.type='button';b.textContent=l;
      b.style.cssText='flex:1;padding:10px 4px;border:none;border-bottom:3px solid '+(a?'#fff':'transparent')+';background:none;font-size:15px;font-weight:'+(a?'800':'400')+';cursor:pointer;color:'+(a?'#fff':'rgba(255,255,255,0.5)')+';letter-spacing:0.02em;transition:all 0.15s;text-align:center;';
      b.addEventListener('click',function(){cb(v);});el.appendChild(b);
    });
  }
  // ── Stage buttons (fat white on pastel banner) ──
  function mkStageRow(id,opts,cur,cb){
    var el=document.getElementById(id);el.innerHTML='';
    var triSub={t1:'trimester',t2:'trimester',t3:'trimester'};
    opts.forEach(function(o){
      var v=typeof o==='string'?o:o.v,l=typeof o==='string'?o:o.l,a=cur===v;
      var b=document.createElement('button');b.type='button';
      var sub=triSub[v]?'<span style="display:block;font-size:10px;font-weight:400;letter-spacing:0.08em;margin-top:2px;font-variant:small-caps;">trimester</span>':'';
      b.innerHTML='<span style="font-size:18px;font-weight:800;letter-spacing:0.02em;line-height:1.2;">'+l+'</span>'+sub;
      b.style.cssText='flex:1;padding:10px 6px;border:none;border-bottom:3px solid '+(a?'#fff':'transparent')+';background:none;cursor:pointer;color:'+(a?'#fff':'rgba(255,255,255,0.5)')+';text-align:center;transition:all 0.15s;';
      b.addEventListener('click',function(){cb(v);});el.appendChild(b);
    });
  }
  function onBuilderSizePick(v){
    if(PDP_HANDLE)enterPackBuilderMode();
    pickSz(v,{syncNative:true,revealBuilder:true});
  }

  function pickSz(v,opts){
    opts=opts||{};
    var allowToggle=opts.allowToggle!==false;
    var nextSize=(allowToggle&&sz===v&&_userPickedSz)?null:v;
    sz=nextSize;
    _userPickedSz=!!nextSize;
    if(PDP_HANDLE&&sz&&opts.syncNative!==false)applyPdpSizeToNativePicker(sz);
    mkRow('sz-row',SIZES,sz,onBuilderSizePick);
    updAtc();
    loadCarousels();
    categoryOverrides={};
    if(typeof renderSizeSummary==='function')renderSizeSummary();
    resolveCurrentSet();
    if(sz&&opts.revealBuilder!==false){
      revealPackBuilderForSelectedSize();
    }
    updateHomepageReveal();
  }

  function redistributeQuantities(){
    if(!resolvedProducts)return;
    // Build set of resolved original handles
    var resolvedHandles={};
    resolvedProducts.forEach(function(rp){resolvedHandles[rp.originalHandle]=true;});

    // For each kit, check if the target qty is met
    for(var kName in KITS){
      var k=KITS[kName];
      var targetTotal=k.totalItems;
      var currentTotal=0;
      var availableSlots=[];

      k.qty.forEach(function(q,i){
        var handle=IDX_TO_HANDLE[i];
        if(q>0&&handle&&resolvedHandles[handle]){
          currentTotal+=q;
          availableSlots.push(i);
        }
      });

      // If we're short, spread extra across available slots
      var deficit=targetTotal-currentTotal;
      if(deficit>0&&availableSlots.length>0){
        // Make a copy of the qty array so we don't mutate the stage template
        var newQty=k.qty.slice();
        var slotIdx=0;
        while(deficit>0){
          newQty[availableSlots[slotIdx%availableSlots.length]]++;
          deficit--;
          slotIdx++;
        }
        k.qty=newQty;
      }
    }
  }

  // ── Hero product carousel ──
  var PMETA = cfg.PMETA || [];
  var pmetaMap = {};
  PMETA.forEach(function(m) { pmetaMap[m.handle] = m; });

  function renderHeroCarousel() {
    var sg = stageGroup;
    var groups = STAGE_PRODUCTS[sg].groups;
    var activeQty = getActiveBaseQty();
    if (!activeQty.length && !customItems.length) return;

    // PDP single: show current product
    if(kit==='single'&&PDP_HANDLE){
      var pdpMeta=pmetaMap[PDP_HANDLE]||{};
      var pdpImg=pdpMeta.hero||'';
      if(!pdpImg&&document.querySelector('#pdp-gallery img'))pdpImg=document.querySelector('#pdp-gallery img').src;
      var pdpItems=[{heroImg:pdpImg,coreName:PDP_NAME||'',details:'',tagline:'',qty:1}];
      var h='<div class="mes-carousel" style="gap:4px;">';
      pdpItems.forEach(function(item){
        h+='<div style="flex:0 0 70%;max-width:70%;scroll-snap-align:start;position:relative;">';
        if(item.heroImg)h+='<img src="'+item.heroImg+'" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;" loading="lazy">';
        h+='<div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:72px;font-weight:900;color:#fff;line-height:1;pointer-events:none;">x'+item.qty+'</div>';
        h+='<div style="padding:8px 4px 0;"><div style="font-size:15px;font-weight:700;line-height:1.3;">'+item.coreName+'</div></div></div>';
      });
      h+='</div>';
      ['mob-hero-products','desk-hero-products'].forEach(function(id){var el=document.getElementById(id);if(el){el.innerHTML=h;el.style.display='block';}});
      return;
    }

    // Collect products that are in the current kit with qty > 0
    var items = [];
    var seen = {};
    groups.forEach(function(g) {
      g.items.forEach(function(item) {
        var handle = IDX_TO_HANDLE[item.idx];
        var qty = activeQty[item.idx] || 0;
        if (qty <= 0 || !handle || seen[handle]) return;
        seen[handle] = true;

        // Use resolved product if available (may be a fallback)
        var resolvedHandle = handle;
        if (resolvedProducts) {
          for (var ri = 0; ri < resolvedProducts.length; ri++) {
            if (resolvedProducts[ri].originalHandle === handle) {
              resolvedHandle = resolvedProducts[ri].handle;
              break;
            }
          }
        }

        // Get metadata — try resolved handle first, fall back to original
        var meta = pmetaMap[resolvedHandle] || pmetaMap[handle] || {};
        var heroImg = meta.hero || '';

        // If resolved product is different, fetch its image
        if (resolvedProducts) {
          for (var ri = 0; ri < resolvedProducts.length; ri++) {
            if (resolvedProducts[ri].originalHandle === handle && resolvedProducts[ri].image) {
              heroImg = resolvedProducts[ri].image;
              break;
            }
          }
        }

        // Build label like PDP: core name, then details line
        var coreName = meta.coreName || item.name;
        var details = [];
        if (meta.length) details.push(meta.length);
        if (meta.feature) details.push(meta.feature);
        if (meta.colour) details.push(meta.colour);
        var detailsStr = details.join(' \u00B7 ');
        var tagline = meta.tagline || '';

        items.push({
          heroImg: heroImg,
          coreName: coreName,
          details: detailsStr,
          tagline: tagline,
          handle: handle,
          source: 'base',
          qty: qty,
          normalPrice: (RRP_PER[item.idx]||0)*qty
        });
      });
    });

    // Add custom items from UGC additions
    customItems.forEach(function(ci){
      if(seen[ci.handle])return;
      seen[ci.handle]=true;
      var meta=pmetaMap[ci.handle]||{};
      items.push({
        heroImg:ci.img||meta.hero||'',
        coreName:meta.coreName||ci.name,
        details:'',
        tagline:'',
        qty:ci.qty,
        isCustom:true,
        source:'custom',
        handle:ci.handle,
        normalPrice:(ci.rrp||0)*ci.qty
      });
    });

    if (!items.length) return;

    // Fetch images for custom items that don't have hero images
    var needsFetch=items.filter(function(it){return it.isCustom&&!it.heroImg;});
    var fetchPromises=needsFetch.map(function(it){
      return fetchProduct(it.handle).then(function(prod){
        if(prod&&prod.image)it.heroImg=prod.image;
      }).catch(function(){});
    });

    Promise.all(fetchPromises).then(function(){
      var h = '';
      h += '<div class="mes-carousel" style="gap:4px;">';
      items.forEach(function(item) {
        h += '<div style="flex:0 0 70%;max-width:70%;scroll-snap-align:start;position:relative;">';
        if (item.heroImg) h += '<img src="' + item.heroImg + '" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;" loading="lazy">';
        h += '<div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;pointer-events:none;">';
        h += '<div style="display:flex;align-items:center;justify-content:center;gap:0;width:100%;pointer-events:auto;">';
        h += '<button type="button" data-hero-qty-action="minus" data-hero-handle="'+item.handle+'" data-hero-source="'+item.source+'" style="border:none;background:none;color:#fff;font-size:66px;font-weight:900;line-height:0.8;cursor:pointer;padding:0;margin:0;min-width:0;text-shadow:0 2px 10px rgba(0,0,0,0.32);">-</button>';
        h += '<span style="font-size:78px;font-weight:900;color:#fff;line-height:0.9;white-space:nowrap;margin:0 2px;text-shadow:0 2px 10px rgba(0,0,0,0.32);">x' + item.qty + '</span>';
        h += '<button type="button" data-hero-qty-action="plus" data-hero-handle="'+item.handle+'" data-hero-source="'+item.source+'" style="border:none;background:none;color:#fff;font-size:66px;font-weight:900;line-height:0.8;cursor:pointer;padding:0;margin:0;min-width:0;text-shadow:0 2px 10px rgba(0,0,0,0.32);">+</button>';
        h += '</div></div>';
        h += '<div style="padding:8px 4px 0;">';
        h += '<div style="font-size:15px;font-weight:700;line-height:1.3;">' + item.coreName + '</div>';
        if (item.details) h += '<div style="font-size:11px;color:#374151;text-transform:uppercase;margin-top:2px;">' + item.details + '</div>';
        if (item.tagline) h += '<div style="font-size:11px;color:#6b7280;text-transform:uppercase;margin-top:2px;">' + item.tagline + '</div>';
        if (item.normalPrice) h += formatNormallyLine(item.normalPrice);
        h += '</div></div>';
      });
      h += '</div>';

      // Render into both mobile and desktop containers
      ['mob-hero-products', 'desk-hero-products'].forEach(function(id) {
        var el = document.getElementById(id);
        if (el) {
          el.innerHTML = h;
          el.style.display = 'block';
          el.querySelectorAll('[data-hero-qty-action]').forEach(function(btn){
            btn.addEventListener('click',function(e){
              e.preventDefault();
              e.stopPropagation();
              var delta=btn.getAttribute('data-hero-qty-action')==='plus'?1:-1;
              var handle=btn.getAttribute('data-hero-handle');
              var source=btn.getAttribute('data-hero-source');
              if(source==='custom')adjustCustomItemQty(handle,delta);
              else adjustBaseItemQty(handle,delta);
            });
          });
        }
      });
    });
  }

  // Size mapping per handle. emamaco's bottoms/shapewear/recovery stock the full XXS–XXXL
  // range, but tops/crops (emama-longline-crop, long-line-crop-black) only stock XS–XXL.
  // Recovery/nursing items are typically sized UP by 1 from the user's base size. This helper
  // builds a per-handle size ladder (preferred first, then nearby fallbacks) so that:
  //   user XXS bottoms → ['XXS','XS']                     (try size, then up)
  //   user XXS tops    → ['XS','S']                       (snap to top range, then up)
  //   user XXS recovery→ ['XS','S','XXS']                 (size up, then further up, then base)
  //   user XXXL tops   → ['XXL','XL']                     (snap to top range max)
  //   user XXXL recovery→ ['XXXL','XXL']                  (already at max, can't size up)
  var SIZE_LADDER_ORDER = ['XXS','XS','S','M','L','XL','XXL','XXXL'];
  var LIMITED_TOPS_HANDLES = { 'emama-longline-crop': true, 'long-line-crop-black': true };
  var POSTPARTUM_SIZE_UP_HANDLES = {
    'pregnancy-recovery-emama-7-8-leggings-pockets': true,
    'pregnancy-recovery-emama-shorts-pockets': true,
    'emama-longline-crop': true,
    'long-line-crop-black': true
  };
  function _shiftSize(s, delta) {
    var i = SIZE_LADDER_ORDER.indexOf((s||'').toUpperCase());
    if (i < 0) return s;
    return SIZE_LADDER_ORDER[Math.max(0, Math.min(SIZE_LADDER_ORDER.length-1, i+delta))];
  }
  function _snapToTopsRange(s) {
    // Tops stock XS–XXL only — clamp out-of-range sizes inward
    if (s === 'XXS') return 'XS';
    if (s === 'XXXL') return 'XXL';
    return s;
  }
  function buildSizeLadderForHandle(handle, userSize) {
    var u = (userSize || 'M').toUpperCase();
    // Compute the "preferred" size for this handle's category
    var preferred = u;
    if (POSTPARTUM_SIZE_UP_HANDLES[handle]) preferred = _shiftSize(u, 1);
    if (LIMITED_TOPS_HANDLES[handle]) preferred = _snapToTopsRange(preferred);
    // Build a ladder: preferred, then ±1 around it (don't repeat, prefer up over down)
    var ladder = [preferred];
    var up = _shiftSize(preferred, 1);
    var down = _shiftSize(preferred, -1);
    if (up !== preferred && ladder.indexOf(up) < 0) ladder.push(up);
    if (down !== preferred && ladder.indexOf(down) < 0) ladder.push(down);
    // For tops/crops, never include XXS or XXXL (they don't exist)
    if (LIMITED_TOPS_HANDLES[handle]) {
      ladder = ladder.filter(function(s) { return s !== 'XXS' && s !== 'XXXL'; });
    }
    return ladder;
  }

  function resolveCurrentSet(){
    if(!sz||!window.EmmacoProductResolver)return;
    var sg=getStageGroup(tri);
    var groups=STAGE_PRODUCTS[sg].groups;
    var allItems=[];
    groups.forEach(function(g){g.items.forEach(function(item){
      var handle=IDX_TO_HANDLE[item.idx];
      if(handle)allItems.push({handle:handle,name:item.name,desc:item.desc,qty:1});
    });});
    // Dedupe by handle + attach per-handle size ladder
    var seen={},deduped=[];
    allItems.forEach(function(it){
      if(seen[it.handle])return;
      seen[it.handle]=true;
      var entry = { handle: it.handle, name: it.name, desc: it.desc, qty: it.qty };
      entry.sizes = buildSizeLadderForHandle(it.handle, sz);
      deduped.push(entry);
    });

    // Pass per-product sizes via the resolver's `sizes` override on each product. Don't pass
    // sizeUpForPostPartum here because we've already pre-shifted via buildSizeLadderForHandle.
    window.EmmacoProductResolver.resolveSet(deduped, sz).then(function(results){
      resolvedProducts=results;
      redistributeQuantities();
      renderProductList();
      updQtyBadges();
      renderHeroCarousel();
    });
  }
  var STAGE_SUMMARY={t1:"you're in your 1st trimester, not long now!",t2:"you're in your 2nd trimester, not long now!",t3:"you're in your 3rd trimester, not long now!",pp:"you're post partum - the fun starts now",ml:"welcome to "+MUM+" life"};
  var _userPickedStage=false,_userPickedSz=false;

  function collapseStage(){
    if(!tri)return;
    var exp=document.getElementById('tri-expanded');
    var col=document.getElementById('tri-collapsed');
    var sum=document.getElementById('tri-summary');
    if(exp&&col&&sum){
      exp.style.display='none';
      col.style.display='';
      sum.textContent=STAGE_SUMMARY[tri]||'';
    }
  }
  function collapseSz(){
    if(!sz)return;
    var exp=document.getElementById('sz-expanded');
    var col=document.getElementById('sz-collapsed');
    var sum=document.getElementById('sz-summary');
    if(exp&&col&&sum){
      exp.style.display='none';
      col.style.display='';
      sum.textContent="you're normally a "+sz;
    }
  }

  function pickStage(v){
    if(PDP_HANDLE)enterPackBuilderMode();
    _userPickedStage=true;
    tri=(tri===v?null:v);
    if(IS_HOME&&!tri){
      sz=null;
      resolvedProducts=null;
      mkRow('sz-row',SIZES,sz,onBuilderSizePick);
    }
    mkStageRow('tri-row',STAGES,tri,pickStage);
    if(tri){
      var sizeStep=document.getElementById('mes-step-size');
      if(sizeStep&&sizeStep.style.display==='none'){
        sizeStep.style.display='';
        sizeStep.classList.add('mes-fade-in');
      }
      // Collapse stage selector on user click
      collapseStage();
    }else if(IS_HOME){
      var stageExpanded=document.getElementById('tri-expanded');
      var stageCollapsed=document.getElementById('tri-collapsed');
      if(stageExpanded)stageExpanded.style.display='';
      if(stageCollapsed)stageCollapsed.style.display='none';
    }
    updateHomepageReveal();
    renderStageUI();
    loadCarousels();
    if(typeof renderSizeSummary==='function')renderSizeSummary();
    resolveCurrentSet();
  }
  mkRow('sz-row',SIZES,sz,onBuilderSizePick);mkStageRow('tri-row',STAGES,tri,pickStage);

  // ── Kit selector ──
  function pickKit(k){
    if(PDP_HANDLE)enterPackBuilderMode();
    if(k==='custom'){
      if(!hasCustomPackState())return;
      kit='custom';
    }else{
      lastStandardKit=k;
      customBaseQty=null;
      kit=customItems.length?'custom':k;
    }
    refreshPackUi();
  }
  document.querySelectorAll('#variant-selector button[data-kit]').forEach(function(b){
    b.addEventListener('click',function(){pickKit(b.getAttribute('data-kit'));});
  });

  function updQtyBadges(){
    var activeQty=getActiveBaseQty();
    for(var i=0;i<9;i++){
      var q=activeQty[i]||0;
      var el=document.getElementById('qty-p'+i);
      if(el)el.textContent=q>1?'x'+q:'';
      var row=document.getElementById('row-p'+i);
      if(row)row.style.opacity=q===0?'0.4':'1';
    }
  }

  function updSavings(){
    var totalRrp=getCurrentNormalPrice();
    var totalPrice=getCurrentTotalPrice();
    var saved=totalRrp-totalPrice;

    var box=document.getElementById('savings-box');
    if(!box)return;
    if(kit==='single'&&!customItems.length){
      box.innerHTML='';box.style.display='none';return;
    }
    box.style.display='none';

    // Update hero section prices
    var heroPrice=document.getElementById('mes-set-price');
    if(heroPrice)heroPrice.textContent=S+totalPrice;
    var heroRrp=document.getElementById('mes-set-rrp');
    if(heroRrp)heroRrp.textContent='normally '+S+totalRrp;

    var activeKey=hasCustomPackState()?'custom':kit;
    var priceEl=document.getElementById('price-'+activeKey);
    if(priceEl)priceEl.textContent=S+totalPrice;

    ['essentials','prepared','ultimate'].forEach(function(key){
      var todayEl=document.getElementById('kit-today-'+key);
      if(todayEl)todayEl.textContent=S+KITS[key].price;
    });
    syncCustomPackOption();

    // Show custom item count under selected kit
    var customNote=document.getElementById('kit-custom-note');
    if(!customNote){
      var activeBtn=document.querySelector('#variant-selector button[data-kit="'+activeKey+'"]');
      if(activeBtn){
        customNote=document.createElement('div');
        customNote.id='kit-custom-note';
        customNote.style.cssText='font-size:11px;color:#3D9A8B;margin-top:3px;';
        var inner=activeBtn.querySelector('div > div');
        if(inner)inner.appendChild(customNote);
      }
    }
    if(customNote){
      if(getCustomTotalQty()>0){
        var names=[];customItems.forEach(function(ci){names.push('x'+ci.qty+' '+ci.name);});
        customNote.textContent='+ '+names.join(', ');
      }else{
        customNote.textContent='';
      }
    }

    updatePdpEntryContent();
  }

  // ── ATC ──
  // Social numbers are now stage-aware — accessed via STAGE_SOCIAL[stageGroup]
  // Stage label for button copy: "pregnancy" / "postpartum" / locale-aware "mum" or "mom".
  function getStageLabelForAtc(){
    if(stageGroup==='pregnancy')return 'pregnancy';
    if(stageGroup==='postpartum')return 'postpartum';
    return MUM; // 'mum' (AU/NZ/UK/IE/SG/EU) or 'mom' (US/CA)
  }

  function getBuilderCtaPrefix(activeSale){
    var meta=getStageKitMeta(stageGroup);
    if(kit==='custom')return activeSale?'Lock In My Custom Set':'Add Custom Set';
    if(kit==='single')return activeSale?'Lock In This Piece':((meta.single&&meta.single.cta)||'Add to Cart');
    if(activeSale){
      if(kit==='essentials')return 'Lock In Essentials Set';
      if(kit==='prepared')return 'Lock In Complete Set';
      if(kit==='ultimate')return 'Lock In Best Value Set';
    }
    return (meta[kit]&&meta[kit].cta)||'Add to Cart';
  }

  // Build the state-based ATC label for pack-builder (non-PDP, non-single) mode.
  // Returns { html, disabled }. Tracks current pack item count + tier pricing from JSON.
  function buildPackAtcLabel(){
    var totalItems=getTotalItemCount();
    var totalPrice=getCurrentTotalPrice();
    var saleActive=getFlashSaleState().active;
    if(totalItems<5){
      var need=5-totalItems;
      return {
        html:'Add '+need+' more to unlock 5 for '+fmtMoney(KITS.essentials.price),
        disabled:true
      };
    }
    return {
      html:getBuilderCtaPrefix(saleActive)+' \u2014 '+fmtMoney(totalPrice)+(totalItems>1?' ('+totalItems+' items)':''),
      disabled:false
    };
  }

  function applyPackAtcState(b,state){
    if(!b||!state)return;
    b.innerHTML=state.html;
    b.disabled=!!state.disabled;
    b.style.opacity=state.disabled?'0.55':'1';
    b.style.cursor=state.disabled?'not-allowed':'pointer';
  }

  function updAtc(){
    ensureStickyScaffold();
    if(PDP_HANDLE)syncSizeFromNativePdpPicker({refresh:false});
    var totalItems=getTotalItemCount();
    var totalPrice=getCurrentTotalPrice();
    var saleActive=getFlashSaleState().active;
    // Pack-builder mode (homepage / non-PDP) \u2014 use state-based label per item count.
    var packState=(!PDP_HANDLE&&!isPdpSingleMode())?buildPackAtcLabel():null;
    ['atc','atc2','m-atc'].forEach(function(id){
      var b=document.getElementById(id);
      if(!b)return;
      if(!sz){b.textContent='Select a size';b.disabled=false;b.style.opacity='1';b.style.cursor='pointer';return;}
      if(packState){applyPackAtcState(b,packState);return;}
      // PDP fallback (single product, not pack)
      var label;
      if(!isPdpSingleMode()){
        label=getBuilderCtaPrefix(saleActive)+' \u2014 '+fmtMoney(totalPrice)+(totalItems>1?' ('+totalItems+' items)':'');
      }else if(saleActive){
        label='Lock In This Piece \u2014 '+fmtMoney(totalPrice)+(totalItems>1?' ('+totalItems+' items)':'');
      }else{
        label=IS_HOME?'Buy now \u2014 '+S+totalPrice+' today'+(totalItems>1?' ('+totalItems+' items)':''):
                  'Add to Cart \u2014 '+S+totalPrice+(totalItems>1?' ('+totalItems+' items)':'');
      }
      b.textContent=label;b.disabled=false;b.style.opacity='1';b.style.cursor='pointer';
    });
    var stickyAdd=document.getElementById('atc-sticky');
    if(stickyAdd){
      if(isPdpSingleMode()){
        var pdpSummary=getPdpSingleStateSummary();
        var quantityLabel=pdpSummary.quantity>1?' ('+pdpSummary.quantity+' items)':'';
        stickyAdd.textContent=sz?'Add to Cart \u2014 '+S+pdpSummary.totalPrice+quantityLabel:'Select Size \u2014 '+S+pdpSummary.totalPrice+quantityLabel;
        stickyAdd.disabled=false;
        stickyAdd.style.opacity='1';
        stickyAdd.style.cursor='pointer';
      }else{
        var stickyKitName=getCurrentPackTitle();
        stickyAdd.textContent=sz?(IS_HOME?'Buy now \u2014 '+stickyKitName+' \u00b7 '+S+totalPrice+' today':'Buy now \u2014 '+stickyKitName+' \u00b7 '+S+totalPrice):'Select a size';
        stickyAdd.disabled=false;
        stickyAdd.style.opacity='1';
        stickyAdd.style.cursor='pointer';
      }
    }
    var stickyPackBuilderLink=document.getElementById('sticky-pack-builder-link');
    if(stickyPackBuilderLink)stickyPackBuilderLink.textContent=getStickyPackBuilderLabel();
    var stickyPrices={essentials:KITS.essentials,prepared:KITS.prepared,ultimate:KITS.ultimate};
    Object.keys(stickyPrices).forEach(function(key){
      var priceEl=document.getElementById('sticky-price-'+key);
      if(priceEl&&stickyPrices[key])priceEl.textContent=S+stickyPrices[key].price;
    });
    syncCustomPackOption();
    var sub=document.getElementById('atc-subtext');
    var nums=STAGE_SOCIAL[stageGroup]||STAGE_SOCIAL.pregnancy;
    var socialKey=getActiveSocialKey();
    if(sub)sub.textContent='Bought by '+(nums[socialKey]||'8,354')+' '+MUMS+' this month \u00B7 Easy returns';
    // Update the social proof "sold this month" line to match
    var soldEl=document.getElementById('social-sold-month');
    if(soldEl)soldEl.textContent='\u2713 '+(nums[socialKey]||'8,354')+' sold this month';

    // Progress tiles
    renderProgressTiles();
  }

  function getProgressTiles(){
    var activeQty=getActiveBaseQty();
    if(!activeQty.length&&!customItems.length)return{filled:[],totalFilled:0,targetSlots:0};

    var filled=[];
    var sg=stageGroup;
    var groups=STAGE_PRODUCTS[sg].groups;
    var seen={};
    groups.forEach(function(g){
      g.items.forEach(function(item){
        var qty=activeQty[item.idx]||0;
        if(qty<=0)return;
        var handle=IDX_TO_HANDLE[item.idx];
        if(seen[handle])return; seen[handle]=true;
        var meta=pmetaMap[handle]||{};
        var img=meta.hero||'';
        if(resolvedProducts){
          for(var ri=0;ri<resolvedProducts.length;ri++){
            if(resolvedProducts[ri].originalHandle===handle&&resolvedProducts[ri].image){img=resolvedProducts[ri].image;break;}
          }
        }
        for(var qi=0;qi<qty;qi++)filled.push({img:img});
      });
    });
    customItems.forEach(function(ci){
      var meta=pmetaMap[ci.handle]||{};
      var cImg=ci.img||meta.hero||'';
      for(var qi=0;qi<ci.qty;qi++)filled.push({img:cImg});
    });
    if(kit==='single'&&PDP_HANDLE&&!customItems.length&&!customBaseQty){
      filled=[];
      var pdpMeta=pmetaMap[PDP_HANDLE]||{};
      var pdpImg=pdpMeta.hero||'';
      if(!pdpImg){var gi=document.querySelector('#pdp-gallery img');if(gi)pdpImg=gi.src;}
      filled.push({img:pdpImg});
    }
    var totalFilled=filled.length;
    // Target: next level up from current count
    var levels=[5,7,9];
    // Always show next level: filled + empty pulsing slots to chase
    var targetSlots=totalFilled<=5?7:totalFilled<=7?9:Math.max(9,totalFilled);
    return{filled:filled,totalFilled:totalFilled,targetSlots:targetSlots};
  }

  function updateStickySaleTimer(){
    ensureStickyScaffold();
    var saleLine=document.getElementById('sticky-sale-line');
    var saleTimer=document.getElementById('sticky-sale-timer');
    var saleWrap=document.getElementById('sticky-sale-timer-wrap');
    var homeSaleKicker=document.getElementById('mes-home-sale-kicker');
    var homeSaleTimer=document.getElementById('mes-home-sale-timer');
    if(!saleLine||!saleTimer||!saleWrap)return;
    var flashSale=getFlashSaleApi();
    var state=getFlashSaleState();
    if(state.active&&flashSale){
      saleLine.textContent='3 day flash sale';
      saleTimer.textContent=flashSale.formatCountdown(state.remainingMs);
      saleWrap.style.display='flex';
      if(homeSaleKicker)homeSaleKicker.textContent='3 day flash sale';
      if(homeSaleTimer)homeSaleTimer.textContent=flashSale.formatCountdown(state.remainingMs);
    }else{
      saleLine.textContent='Flash sale live now';
      saleTimer.textContent='Limited time';
      saleWrap.style.display='flex';
      if(homeSaleKicker)homeSaleKicker.textContent='limited time offer';
      if(homeSaleTimer)homeSaleTimer.textContent='limited time';
    }
    renderFlashSaleBuilderUI();
  }

  function startStickySaleTimer(){
    if(stickySaleTimerId)window.clearInterval(stickySaleTimerId);
    updateStickySaleTimer();
    stickySaleTimerId=window.setInterval(updateStickySaleTimer,1000);
  }

  function syncStickySelectorPanel(){
    var stickyEl=document.getElementById('sticky-atc');
    var stickyAdd=document.getElementById('atc-sticky');
    var saleTimerWrap=document.getElementById('sticky-sale-timer-wrap');
    var panel=document.getElementById('sticky-set-panel');
    var chevron=document.getElementById('sticky-set-chevron');
    var toggleBtn=document.getElementById('sticky-set-toggle');
    if(!panel||!toggleBtn)return;
    var compactCollapsed=!!(getComputedStyle(toggleBtn).display!=='none'&&!stickySelectorOpen);
    if(stickyEl)stickyEl.style.padding=compactCollapsed?'4px 12px calc(10px + env(safe-area-inset-bottom))':'12px 14px calc(12px + env(safe-area-inset-bottom))';
    if(toggleBtn){
      toggleBtn.style.marginBottom=compactCollapsed?'4px':'8px';
      toggleBtn.style.lineHeight='1';
    }
    if(saleTimerWrap)saleTimerWrap.style.marginTop=compactCollapsed?'3px':'5px';
    if(stickyAdd){
      stickyAdd.style.padding=compactCollapsed?'12px 12px':'14px 14px';
      stickyAdd.style.marginTop=compactCollapsed?'4px':'6px';
      stickyAdd.style.fontSize=compactCollapsed?'14px':'15px';
    }
    if(getComputedStyle(toggleBtn).display==='none'){
      panel.style.maxHeight='0';
      panel.style.marginTop='0';
      toggleBtn.setAttribute('aria-label','Open set options');
      if(chevron)chevron.textContent='⌃';
      return;
    }
    panel.style.marginTop=stickySelectorOpen?'10px':'0';
    panel.style.maxHeight=stickySelectorOpen?(panel.scrollHeight+24)+'px':'0';
    toggleBtn.setAttribute('aria-label',stickySelectorOpen?'Close set options':'Open set options');
    if(chevron)chevron.textContent=stickySelectorOpen?'⌄':'⌃';
  }

  function toggleStickySelector(forceOpen){
    stickySelectorOpen=typeof forceOpen==='boolean'?forceOpen:!stickySelectorOpen;
    syncStickySelectorPanel();
  }

  function scrollToSetHeadline(){
    toggleStickySelector(false);
    var targets=PDP_HANDLE?['mes-scroll-target','mes-step-stage','mes-step-size','mob-stage-headline','desk-stage-headline']:['mes-step-stage','mes-step-size','mob-stage-headline','desk-stage-headline'];
    var targetEl=null;
    for(var i=0;i<targets.length;i++){
      var candidate=document.getElementById(targets[i]);
      if(candidate&&candidate.offsetParent!==null){targetEl=candidate;break;}
    }
    if(!targetEl)return;
    var top=targetEl.getBoundingClientRect().top+window.pageYOffset-(PDP_HANDLE?96:28);
    window.scrollTo({top:Math.max(top,0),behavior:'smooth'});
  }

  function buildTilesHtml(data,tileSize){
    var h='';
    for(var ti=0;ti<data.targetSlots;ti++){
      var isFilled=ti<data.totalFilled;
      if(isFilled&&data.filled[ti]&&data.filled[ti].img){
        h+='<div style="width:'+tileSize+'px;min-width:'+tileSize+'px;height:'+tileSize+'px;flex-shrink:0;overflow:hidden;"><img src="'+data.filled[ti].img+'" style="width:100%;height:100%;object-fit:cover;display:block;"></div>';
      }else if(isFilled){
        h+='<div style="width:'+tileSize+'px;height:'+tileSize+'px;flex-shrink:0;background:#1f2937;"></div>';
      }else{
        h+='<div style="width:'+tileSize+'px;height:'+tileSize+'px;flex-shrink:0;background:#C4908A;animation:mesTilePulse 2s ease-in-out infinite;"></div>';
      }
    }
    return h;
  }

  function renderProgressTiles(){
    var data=getProgressTiles();
    console.error('[ProgressTiles] filled='+data.totalFilled+' target='+data.targetSlots+' kit='+kit);
    var html=buildTilesHtml(data,32);
    // Sticky ATC tiles
    var tilesEl=document.getElementById('sticky-tiles');
    if(tilesEl){tilesEl.innerHTML=html;console.error('[ProgressTiles] sticky rendered '+tilesEl.children.length+' tiles');}
    // Modal tiles
    var modalTiles=document.getElementById('modal-tiles');
    if(modalTiles)modalTiles.innerHTML=html;
  }

  function ensureStickyScaffold(){
    var stickyEl=document.getElementById('sticky-atc');
    if(!stickyEl)return;
    var inner=stickyEl.firstElementChild||stickyEl;
    var stickyTiles=document.getElementById('sticky-tiles');
    var stickyToggle=document.getElementById('sticky-set-toggle');
    var stickySeeSetLink=document.getElementById('sticky-see-set-link');
    var stickyPanel=document.getElementById('sticky-set-panel');
    var stickyAdd=document.getElementById('atc-sticky');
    if(!stickyAdd)return;
    var saleLine=document.getElementById('sticky-sale-line');
    var saleBlock=saleLine&&saleLine.parentElement&&saleLine.parentElement.parentElement?saleLine.parentElement.parentElement:null;
    var inPackBuilderState=!isPdpSingleMode();

    if(!document.getElementById('sticky-sale-line')){
      var saleBlock=document.createElement('div');
      saleBlock.style.display='block';
      saleBlock.innerHTML='<div style="min-width:0;text-align:center;"><div id="sticky-sale-line" style="font-size:11px;font-weight:800;letter-spacing:0.14em;text-transform:uppercase;color:#b42318;line-height:1.2;">Flash sale live now</div><div id="sticky-sale-timer-wrap" style="display:flex;align-items:center;justify-content:center;gap:6px;margin-top:5px;font-size:12px;color:#1f2937;line-height:1.2;"><span style="font-weight:500;opacity:0.74;">Ends in</span><span id="sticky-sale-timer" style="font-weight:800;letter-spacing:0.08em;">--:--:--</span></div></div>';
      inner.insertBefore(saleBlock,stickyAdd);
    }

    if(!stickyTiles){
      stickyTiles=document.createElement('div');
      stickyTiles.id='sticky-tiles';
      stickyTiles.style.cssText='display:none;gap:2px;margin:0 0 8px 0;flex-wrap:nowrap;align-items:center;overflow-x:auto;scrollbar-width:none;-webkit-overflow-scrolling:touch;';
      inner.insertBefore(stickyTiles,inner.firstChild);
    }

    if(!stickyToggle){
      stickyToggle=document.createElement('button');
      stickyToggle.id='sticky-set-toggle';
      stickyToggle.type='button';
      stickyToggle.setAttribute('aria-label','Open set options');
      stickyToggle.style.cssText='display:none;width:100%;margin:0 0 4px 0;padding:0;background:none;border:none;color:#1f2937;font-size:12px;font-weight:700;letter-spacing:0.03em;line-height:1;cursor:pointer;';
      stickyToggle.innerHTML='<span style="display:inline-flex;align-items:center;justify-content:center;"><span id="sticky-set-chevron" style="font-size:16px;line-height:1;color:#1f2937;">⌃</span></span>';
      if(saleBlock)inner.insertBefore(stickyToggle,saleBlock);
      else inner.insertBefore(stickyToggle,stickyAdd);
    }

    if(!document.getElementById('sticky-pack-builder-link')){
      var packLink=document.createElement('button');
      packLink.id='sticky-pack-builder-link';
      packLink.type='button';
      packLink.style.cssText='display:block;width:100%;margin-top:8px;padding:0;background:none;border:none;color:#1f2937;font-size:12px;font-weight:700;letter-spacing:0.03em;text-decoration:underline;cursor:pointer;';
      packLink.textContent=getStickyPackBuilderLabel();
      stickyAdd.insertAdjacentElement('afterend',packLink);
    }

    if(!stickyPanel){
      stickyPanel=document.createElement('div');
      stickyPanel.id='sticky-set-panel';
      stickyPanel.style.cssText='display:none;max-height:0;overflow:hidden;transition:max-height 0.28s ease,margin-top 0.28s ease;';
      stickyPanel.innerHTML='<div id="sticky-set-options" style="display:flex;flex-direction:column;gap:8px;padding-top:10px;"></div><button id="sticky-see-set-link" type="button" style="display:block;width:100%;margin-top:10px;padding:0;background:none;border:none;color:#1f2937;font-size:12px;font-weight:700;letter-spacing:0.03em;text-decoration:underline;cursor:pointer;">see what i get in this set</button>';
      var packLinkEl=document.getElementById('sticky-pack-builder-link');
      if(packLinkEl)packLinkEl.insertAdjacentElement('afterend',stickyPanel);
      stickySeeSetLink=document.getElementById('sticky-see-set-link');
    }

    if(stickyTiles)stickyTiles.style.display='none';
    if(stickyToggle){
      stickyToggle.style.display=inPackBuilderState?'block':'none';
      if(inPackBuilderState){
        if(saleBlock)inner.insertBefore(stickyToggle,saleBlock);
        else inner.insertBefore(stickyToggle,stickyAdd);
      }
    }

    var packBuilderLink=document.getElementById('sticky-pack-builder-link');
    if(packBuilderLink){
      packBuilderLink.textContent=getStickyPackBuilderLabel();
      packBuilderLink.style.display=inPackBuilderState?'none':'block';
    }

    if(stickySeeSetLink)stickySeeSetLink.style.display=inPackBuilderState?'block':'none';
    if(stickyPanel){
      stickyPanel.style.display=inPackBuilderState?'block':'none';
      if(!inPackBuilderState){
        stickySelectorOpen=false;
        stickyPanel.style.maxHeight='0';
        stickyPanel.style.marginTop='0';
      }
    }
    syncStickySelectorPanel();
  }

  function bindStickyControls(){
    var stickyToggle=document.getElementById('sticky-set-toggle');
    if(stickyToggle&&!stickyToggle.dataset.boundToggle){
      stickyToggle.dataset.boundToggle='true';
      stickyToggle.addEventListener('click',function(){toggleStickySelector();});
    }
    var stickyPackBuilderLink=document.getElementById('sticky-pack-builder-link');
    if(stickyPackBuilderLink&&!stickyPackBuilderLink.dataset.boundScroll){
      stickyPackBuilderLink.dataset.boundScroll='true';
      stickyPackBuilderLink.addEventListener('click',scrollToSetHeadline);
    }
    var stickySeeSetLink=document.getElementById('sticky-see-set-link');
    if(stickySeeSetLink&&!stickySeeSetLink.dataset.boundScroll){
      stickySeeSetLink.dataset.boundScroll='true';
      stickySeeSetLink.addEventListener('click',scrollToSetHeadline);
    }
  }

  // Size picker modal (shown when ATC tapped without a size)
  function openSizeModal(){
    var options=arguments[0]||{};
    var modal=document.createElement('div');
    modal.style.cssText='position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,0.5);display:flex;align-items:flex-end;justify-content:center;font-family:system-ui,-apple-system,sans-serif;';
    var inner='<div style="background:#fff;border-radius:16px 16px 0 0;padding:24px 20px 32px;max-width:480px;width:100%;">';
    inner+='<div style="display:flex;justify-content:space-between;align-items:center;margin:0 0 16px 0;"><div style="font-size:17px;font-weight:700;">Your normal leggings size</div><button id="sz-modal-close" style="background:none;border:none;font-size:20px;cursor:pointer;">\u2715</button></div>';
    inner+='<div id="sz-modal-row" style="display:flex;flex-wrap:wrap;gap:8px;"></div>';
    inner+='</div>';
    modal.innerHTML=inner;
    document.body.appendChild(modal);

    var row=modal.querySelector('#sz-modal-row');
    SIZES.forEach(function(s){
      var b=document.createElement('button');b.type='button';b.textContent=s;
      b.style.cssText='padding:12px 18px;border:1.5px solid #e5e7eb;border-radius:8px;background:#fff;font-size:15px;font-weight:600;cursor:pointer;min-width:52px;color:#1f2937;';
      b.addEventListener('click',function(){
        pickSz(s,options.pickOptions||{allowToggle:false,syncNative:true,revealBuilder:false});
        modal.remove();
        if(typeof options.afterPick==='function')options.afterPick(s);
      });
      row.appendChild(b);
    });

    modal.querySelector('#sz-modal-close').addEventListener('click',function(){modal.remove();});
    modal.addEventListener('click',function(e){if(e.target===modal)modal.remove();});
  }

  function onAtcClick(){
    if(isPdpSingleMode()){
      doPdpSingleAtc();
      return;
    }
    if(!sz){openSizeModal();return;}
    doAtc();
  }

  function doPdpSingleAtc(forcedSize,buttonIds){
    var targetSize=normalizePdpSize(forcedSize)||syncSizeFromNativePdpPicker({refresh:false})||normalizePdpSize(sz);
    if(!targetSize){
      openSizeModal({
        pickOptions:{allowToggle:false,syncNative:true,revealBuilder:false},
        afterPick:function(chosenSize){doPdpSingleAtc(chosenSize,buttonIds);}
      });
      return;
    }
    applyPdpSizeToNativePicker(targetSize);
    sz=targetSize;
    resolveCurrentSet();
    if(typeof renderSizeSummary==='function')renderSizeSummary();
    updAtc();

    var variantId=getPdpSingleVariantId(targetSize);
    if(!variantId)return;
    var quantity=getPdpPageQuantity();
    var ids=buttonIds&&buttonIds.length?buttonIds:['atc-sticky'];
    ids.forEach(function(id){var b=document.getElementById(id);if(b){b.disabled=true;b.textContent='Adding...';}});
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(variantId),quantity:quantity}]})})
    .then(function(r){return r.json();})
    .then(function(){window.location.href='/cart';})
    .catch(function(){ids.forEach(function(id){var b=document.getElementById(id);if(b){b.disabled=false;}});updAtc();});
  }

  function doAtc(){
    if(!sz)return;
    var activeQty=getActiveBaseQty();
    var items=[];

    // Build a map of resolved products for variant ID lookup
    var resolvedMap={};
    if(resolvedProducts){
      resolvedProducts.forEach(function(rp){ resolvedMap[rp.originalHandle]=rp; });
    }

    activeQty.forEach(function(q,i){
      if(q<=0)return;
      var handle=IDX_TO_HANDLE[i];
      var resolved=handle?resolvedMap[handle]:null;

      if(resolved&&resolved.variantId){
        // Use resolved variant (may be a fallback product)
        var item={id:resolved.variantId,quantity:q};
        if(resolved.preorderNote)item.properties={"Ships":resolved.preorderNote};
        items.push(item);
      } else if(!resolvedProducts && P[i]&&P[i].v&&P[i].v[sz]){
        // Static-variant fallback only when the resolver hasn't run at all (e.g. resolver lib
        // failed to load). When resolver HAS run but a slot didn't resolve, that means the
        // primary + every fallback in its FALLBACK_CHAIN is OOS in the user's size — pushing
        // P[i].v[sz] would post the OOS variant and Shopify rejects the whole ATC payload (422).
        items.push({id:P[i].v[sz],quantity:q});
      }
      // else: resolver ran but this slot is unresolvable in user's size — skip silently.
    });

    customItems.forEach(function(ci){
      if(ci.qty>0&&ci.variantId)items.push({id:ci.variantId,quantity:ci.qty});
    });
    if(!items.length){
      // Nothing resolvable for the user's size — show a friendly banner instead of silent fail.
      var bn=document.getElementById('mes-pack-oos-banner');
      if(!bn){
        bn=document.createElement('div');
        bn.id='mes-pack-oos-banner';
        bn.style.cssText='position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:99999;background:#b42318;color:#fff;padding:12px 18px;border-radius:6px;font-size:13px;font-weight:600;font-family:system-ui,-apple-system,sans-serif;box-shadow:0 4px 12px rgba(0,0,0,0.18);max-width:320px;text-align:center;line-height:1.45;';
        document.body.appendChild(bn);
      }
      bn.textContent='We’re out of your size in this set right now — try a different stage or come back next batch.';
      setTimeout(function(){if(bn&&bn.parentNode)bn.parentNode.removeChild(bn);},6000);
      return;
    }
    ['atc','atc2','atc-sticky'].forEach(function(id){var b=document.getElementById(id);if(b){b.disabled=true;b.textContent='Adding...';}});
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){return r.json();})
    .then(function(){if(kit==='single'){document.getElementById('upsell').style.display='flex';updAtc();}else{window.location.href='/cart';}})
    .catch(function(){['atc','atc2','atc-sticky'].forEach(function(id){var b=document.getElementById(id);if(b){b.disabled=false;b.textContent='Something went wrong';}});});
  }
  document.getElementById('atc').addEventListener('click',onAtcClick);
  var _atc2=document.getElementById('atc2');if(_atc2)_atc2.addEventListener('click',onAtcClick);
  ensureStickyScaffold();
  bindStickyControls();
  document.getElementById('atc-sticky').addEventListener('click',onAtcClick);
  document.querySelectorAll('[data-sticky-kit]').forEach(function(btn){
    btn.addEventListener('click',function(){
      pickKit(btn.getAttribute('data-sticky-kit'));
    });
  });
  document.getElementById('up-no').addEventListener('click',function(){document.getElementById('upsell').style.display='none';window.location.href='/cart';});
  document.getElementById('up-yes').addEventListener('click',function(){document.getElementById('upsell').style.display='none';pickKit('essentials');fetch('/cart/clear.js',{method:'POST'}).then(function(){rebuildKits();var k=KITS.essentials;var items=[];k.qty.forEach(function(q,i){if(q>0&&P[i]){var vid=P[i].v?P[i].v[sz]:null;if(vid)items.push({id:vid,quantity:q});}});return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})});}).then(function(){window.location.href='/cart';});});

  // ── Sticky ATC: arm when the user reaches the pack builder and keep it visible below that point ──
  (function(){
    var stickyEl=document.getElementById('sticky-atc');
    var setBuilder=document.getElementById('mes')||document.getElementById('pdp-set-builder');
    var setStep=document.getElementById('mes-step-set');
    var pdpTrigger=document.getElementById('mes-scroll-target')||document.getElementById('mes-step-size');
    if(!stickyEl||!setBuilder)return;

    var hasEnteredPackBuilder=false;

    function updateStickyVisibility(){
      if(PDP_HANDLE){
        stickyEl.style.display='block';
        return;
      }
      var triggerEl=PDP_HANDLE?(pdpTrigger||setBuilder):setBuilder;
      var isPackBuilderOpen=!!(sz&&setStep&&getComputedStyle(setStep).display!=='none');
      var canShowSticky=PDP_HANDLE||isPackBuilderOpen;
      if(!canShowSticky){
        hasEnteredPackBuilder=false;
        stickyEl.style.display='none';
        return;
      }

      var rect=triggerEl.getBoundingClientRect();
      var sectionTop=rect.top+window.pageYOffset;
      var viewportBottom=window.pageYOffset+window.innerHeight;

      if(viewportBottom>=sectionTop){
        hasEnteredPackBuilder=true;
      } else {
        hasEnteredPackBuilder=false;
      }

      stickyEl.style.display=hasEnteredPackBuilder?'block':'none';
    }

    updateStickyVisibility();
    window.addEventListener('scroll',updateStickyVisibility,{passive:true});
    window.addEventListener('resize',updateStickyVisibility);
  })();

  startStickySaleTimer();
  ensurePdpSingleDefaults();
  startPdpSingleStateSync();
  if(PDP_HANDLE&&isPdpSingleMode())updAtc();
  syncStickySelectorPanel();
  updateHomepageReveal();

  // ── Wearing info (under tile, not overlay) ──
  function stageText(item){
    if(item.trimester&&STAGE_LABELS[item.trimester])return STAGE_LABELS[item.trimester];
    if(item.stage==='m')return'in her pregnancy';
    if(item.stage==='p')return STAGE_LABELS.p;
    if(item.stage==='k')return STAGE_LABELS.k;
    return'';
  }

  // Map product handles to their P[] index for set membership checking
  var HANDLE_TO_IDX={
    '7-8-mat-pocket-leggings-black':0,
    'emama-longline-crop':1,
    'shorts-mat-pocket-black':2,
    'pregnancy-recovery-emama-7-8-leggings-pockets':3,
    'pregnancy-recovery-emama-shorts-pockets':4,
    'shorts-shaper-move-pockets-black':5,
    '7-8-shaper-move-leggings-pockets-black':6,
    'long-line-crop-black':7,
    'body-shapewear-shorts-pockets':8,
  };

  function adjustBaseItemQty(handle,delta){
    if(PDP_HANDLE)enterPackBuilderMode();
    var idx=HANDLE_TO_IDX[handle];
    if(idx===undefined||!delta)return;
    var nextQty=getActiveBaseQty();
    var current=nextQty[idx]||0;
    var next=current+delta;
    if(next<0)return;
    nextQty[idx]=next;
    if(sumQtyArray(nextQty)+getCustomTotalQty()<1)return;
    customBaseQty=nextQty;
    refreshPackUi();
  }

  function adjustCustomItemQty(handle,delta){
    if(HANDLE_TO_IDX[handle]!==undefined){
      adjustBaseItemQty(handle,delta);
      return;
    }
    for(var i=0;i<customItems.length;i++){
      if(customItems[i].handle!==handle)continue;
      customItems[i].qty+=delta;
      if(customItems[i].qty<=0)customItems.splice(i,1);
      if(getBaseItemCount()+getCustomTotalQty()<1)return;
      refreshPackUi();
      return;
    }
  }

  function seedPdpInitialSelection(){
    if(!PDP_HANDLE)return;
    pendingPdpCustomSeed=false;
  }

  function isInCurrentSet(handle){
    var idx=HANDLE_TO_IDX[handle];
    if(idx===undefined)return false;
    var activeQty=getActiveBaseQty();
    if(!activeQty.length)return false;
    return (activeQty[idx]||0)>0;
  }

  function isCustomAdded(handle){
    for(var i=0;i<customItems.length;i++){if(customItems[i].handle===handle)return true;}
    return false;
  }

  function productLines(item){
    if(!item.products||!item.products.length)return[];
    var userSz=(sz||'XS').toUpperCase();
    var lines=[],seen={};
    item.products.forEach(function(prod){
      var name=PRODUCT_NAME_MAP[prod.handle];
      if(!name)name=prod.title||prod.handle;
      if(seen[name])return;
      seen[name]=true;
      var inSet=isInCurrentSet(prod.handle);
      var alreadyCustom=isCustomAdded(prod.handle);
      lines.push({name:name,size:userSz,inSet:inSet,handle:prod.handle,alreadyCustom:alreadyCustom});
    });
    return lines;
  }

  function buildInfoHtml(item){
    var h='<div style="padding:10px 12px;background:#111;font-size:12px;color:rgba(255,255,255,0.8);line-height:1.5;">';
    h+='<div>this is <strong>@'+(item.handle||'unknown')+'</strong> '+stageText(item)+'</div>';
    var prods=productLines(item);
    if(prods.length){
      h+='<div style="margin-top:4px;">she\u2019s wearing:</div>';
      prods.forEach(function(p,i){
        var prefix=i>0?'& ':'';
        if(p.inSet){
          h+='<div style="margin-top:2px;">'+prefix+p.name+' in size '+p.size+' <span style="display:inline-block;font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:0.03em;background:#3D9A8B;color:#fff;padding:1px 4px;margin-left:4px;">in your set</span></div>';
        } else if(p.alreadyCustom){
          h+='<div style="margin-top:2px;">'+prefix+p.name+' in size '+p.size+' <span style="display:inline-block;font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:0.03em;background:#3D9A8B;color:#fff;padding:1px 4px;margin-left:4px;">added</span></div>';
        } else {
          var addPrice=getCustomItemPrice();
          var normalPrice=getNormalPriceForHandle(p.handle,1);
          h+='<div style="margin-top:2px;">'+prefix+p.name+' in size '+p.size+' <span class="mes-add-item" data-handle="'+p.handle+'" data-size="'+(p.size||'').toUpperCase()+'" data-name="'+p.name.replace(/"/g,'&quot;')+'" style="display:inline-block;font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:0.03em;background:#E8846C;color:#fff;padding:2px 6px;margin-left:4px;cursor:pointer;">add to your set '+S+addPrice+'</span></div>';
          h+='<div data-mes-normal-price-handle="'+p.handle+'" data-mes-normal-price-qty="1" style="font-size:11px;color:#9ca3af;margin-top:3px;line-height:1.3;'+(normalPrice?'':'display:none;')+'">'+(normalPrice?('normally '+S+Math.ceil(normalPrice)):'')+'</div>';
        }
      });
    }
    h+='</div>';
    return h;
  }

  // ── Build a card (media + info underneath) ──
  function buildCard(item,width){
    var card=document.createElement('div');
    card.style.cssText='flex:0 0 '+width+';max-width:'+width+';scroll-snap-align:start;overflow:hidden;background:#000;cursor:pointer;';
    var isV=item.type==='reel'||item.type==='video';
    var media;
    if(isV)media='<video src="'+ru(item.url)+'" poster="'+ru(item.posterUrl||'')+'" playsinline loop muted preload="metadata" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;"></video>';
    else media='<img src="'+ru(item.url)+'" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;" loading="lazy">';
    card.innerHTML='<div style="position:relative;">'+media+'</div>'+buildInfoHtml(item);
    addSoundBtn(card);
    hydrateNormalPriceLines(card);
    hydrateAvailability(card);
    // Wire "add to your set" badges
    card.querySelectorAll('.mes-add-item').forEach(function(badge){
      badge.addEventListener('click',function(e){
        e.stopPropagation();
        if(badge.classList.contains('mes-sold-out'))return;
        addCustomItem(badge.getAttribute('data-handle'),badge.getAttribute('data-name'));
      });
    });
    card.addEventListener('click',function(e){
      if(e.target.closest('.mes-sound-btn')||e.target.closest('.mes-add-item'))return;
      var idx=0;
      for(var i=0;i<allUgc.length;i++){if(allUgc[i].id===item.id){idx=i;break;}}
      window.openUgcModal(allUgc,idx);
    });
    return card;
  }

  // ── Fetch stages for UGC ──
  var ALL_UGC_STAGES=[
    {tag:'m',tri:'t1',label:'1st Trimester'},
    {tag:'m',tri:'t2',label:'2nd Trimester'},
    {tag:'m',tri:'t3',label:'3rd Trimester'},
    {tag:'p',tri:null,label:'Postpartum'},
    {tag:'k',tri:null,label:MUM_CAP+' Life'}
  ];

  function getUgcStages(){
    var sg=getStageGroup(tri);
    var stages=Array.isArray(ALL_UGC_STAGES)?ALL_UGC_STAGES:[];
    if(sg==='postpartum')return stages.filter(function(s){return s.tag==='p';});
    if(sg==='mumlife')return stages.filter(function(s){return s.tag==='k';});
    // Pregnancy: if specific trimester selected, show that + neighbours; otherwise all pregnancy
    if(tri&&tri!=='pp'&&tri!=='ml'){
      return stages.filter(function(s){return s.tag==='m';});
    }
    return stages;
  }

  // Fetch all maternity content once, then split by trimester client-side
  var fetchCache={};
  function fetchByTag(tag){
    if(fetchCache[tag])return Promise.resolve(fetchCache[tag]);
    var params='tenantId='+encodeURIComponent(TN)+'&pdp=true&limit=100&tags='+tag;
    if(sz) params+='&sizes='+encodeURIComponent(sz)+'&sizeField=bottoms';
    return fetch(CDN+'/api/ugc-gallery?'+params).then(function(r){return r.json();}).then(function(d){
      var items=d.ok&&d.items?d.items:[];
      fetchCache[tag]=items;
      return items;
    }).catch(function(){return[];});
  }
  function fetchStage(st){
    return fetchByTag(st.tag).then(function(items){
      if(!st.tri)return items; // p, k -- return all
      // For maternity, filter to matching trimester
      return items.filter(function(it){return it.trimester===st.tri;});
    });
  }

  function loadCarousels(){
    allUgc=[];fetchCache={};
    // Clear both mobile and desktop tracks
    for(var t=0;t<3;t++){
      var tr=document.getElementById('stage-track-'+t);if(tr)tr.innerHTML='';
      var dtr=document.getElementById('desk-stage-track-'+t);if(dtr)dtr.innerHTML='';
    }
    var _ss=document.getElementById('stage-section');if(_ss)_ss.style.display='none';
    var _dss=document.getElementById('desk-stage-section');if(_dss)_dss.style.display='none';
    var _smb=document.getElementById('see-more-btn');if(_smb)_smb.style.display='none';
    var _dsmb=document.getElementById('desk-see-more-btn');if(_dsmb)_dsmb.style.display='none';

    Promise.all(getUgcStages().map(fetchStage)).then(function(results){
      // Collect all items deduped
      var seen={},allItems=[];
      results.forEach(function(items){items.forEach(function(it){if(!seen[it.id]){seen[it.id]=true;allItems.push(it);}});});
      allUgc=allItems;

      // Build per-person stage map: { handle: { t1: item, t2: item, ... } }
      var personStages={};
      allItems.forEach(function(it){
        if(!it.handle)return;
        var sk=itemStageKey(it);
        if(!sk)return;
        if(!personStages[it.handle])personStages[it.handle]={};
        if(!personStages[it.handle][sk])personStages[it.handle][sk]=it;
      });

      // Rank people by how many stages they cover
      var people=Object.keys(personStages).sort(function(a,b){
        return Object.keys(personStages[b]).length-Object.keys(personStages[a]).length;
      }).slice(0,3);

      // Render: one person per row, strict stage order
      var globalUsed={};
      people.forEach(function(handle,rowIdx){
        var track=document.getElementById('stage-track-'+rowIdx);
        var dtrack=document.getElementById('desk-stage-track-'+rowIdx);
        var map=personStages[handle];
        STAGE_ORDER.forEach(function(sk){
          var it=map[sk];
          if(!it||globalUsed[it.id])return;
          globalUsed[it.id]=true;
          if(track)track.appendChild(buildCard(it,'80%'));
          if(dtrack)dtrack.appendChild(buildCard(it,'80%'));
        });
      });

      if(allItems.length){
        if(_ss){_ss.style.display='block';addSoundBtn(_ss);}
        if(_dss){_dss.style.display='block';addSoundBtn(_dss);}
        setupVideoVisibility();
        // Add desktop scroll arrows to all carousel tracks
        for(var ai=0;ai<3;ai++){
          addScrollArrows(document.getElementById('stage-track-'+ai));
          addScrollArrows(document.getElementById('desk-stage-track-'+ai));
        }
      }
      if(allItems.length>5){
        if(_smb)_smb.style.display='block';
        if(_dsmb)_dsmb.style.display='block';
      }

      // Auto-scrolling mini carousel above hero
      var autoWrap=document.getElementById('mes-auto-carousel-wrap');
      var autoTrack=document.getElementById('mes-auto-carousel');
      if(autoTrack&&autoWrap&&allItems.length){
        autoTrack.innerHTML='';
        // Use all items from the 3 people, grouped by person
        var autoItems=[];
        people.forEach(function(handle){
          var map=personStages[handle];
          STAGE_ORDER.forEach(function(sk){
            var it=map[sk];
            if(it)autoItems.push(it);
          });
        });
        if(autoItems.length){
          // Duplicate items for seamless loop
          var duped=autoItems.concat(autoItems).concat(autoItems);
          duped.forEach(function(it){
            var url=it.posterUrl||it.url;
            if(!url)return;
            url=url.startsWith('http')?url:CDN+(url.startsWith('/')?'':'/')+url;
            var card=document.createElement('div');
            card.style.cssText='flex:0 0 72px;width:72px;height:96px;overflow:hidden;';
            var img=document.createElement('img');
            img.src=url;
            img.style.cssText='width:100%;height:100%;object-fit:cover;display:block;';
            img.loading='lazy';
            card.appendChild(img);
            autoTrack.appendChild(card);
          });
          autoWrap.style.display='block';
          // Animate: scroll left continuously
          var totalW=(72+3)*autoItems.length;
          autoTrack.style.animation='mesAutoScroll '+Math.max(autoItems.length*3,12)+'s linear infinite';
          if(!document.getElementById('mes-auto-scroll-css')){
            var css=document.createElement('style');css.id='mes-auto-scroll-css';
            css.textContent='@keyframes mesAutoScroll{0%{transform:translateX(0);}100%{transform:translateX(-'+totalW+'px);}}';
            document.head.appendChild(css);
          }
        }
      }
    });
  }
  loadCarousels();

  // See more buttons (mobile + desktop, both optional)
  var _seeMore=document.getElementById('see-more-btn');
  if(_seeMore){_seeMore.addEventListener('click',function(){
    if(allUgc.length)window.openUgcModal(allUgc,0);
  });}
  var _dSeeMore=document.getElementById('desk-see-more-btn');
  if(_dSeeMore){_dSeeMore.addEventListener('click',function(){
    if(allUgc.length)window.openUgcModal(allUgc,0);
  });}

  // ── UGC Modal (2 modes: journeys / by trimester) ──
  var STAGE_ORDER=['t1','t2','t3','p','k'];
  var STAGE_TAB_LABELS={t1:'1st Tri',t2:'2nd Tri',t3:'3rd Tri',p:'Postpartum',k:MUM_CAP+' Life'};

  function stageSort(a,b){
    var aKey=a.trimester||(a.stage==='p'?'p':a.stage==='k'?'k':'z');
    var bKey=b.trimester||(b.stage==='p'?'p':b.stage==='k'?'k':'z');
    return STAGE_ORDER.indexOf(aKey)-STAGE_ORDER.indexOf(bKey);
  }

  function itemStageKey(it){return it.trimester||(it.stage==='p'?'p':it.stage==='k'?'k':null);}

  function buildCardHtml(it){
    var isV=it.type==='reel'||it.type==='video';
    var h='<div style="background:#000;overflow:hidden;position:relative;">';
    if(isV)h+='<video src="'+ru(it.url)+'" poster="'+ru(it.posterUrl||'')+'" playsinline loop muted preload="metadata" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;"></video>';
    else h+='<img src="'+ru(it.url)+'" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;" loading="lazy">';
    h+='</div>';
    h+=buildInfoHtml(it);
    return h;
  }

  var _modalScrollY=0;
  function _lockBody(){_modalScrollY=window.scrollY;document.body.style.position='fixed';document.body.style.top='-'+_modalScrollY+'px';document.body.style.left='0';document.body.style.right='0';document.body.style.overflow='hidden';}
  function _unlockBody(){document.body.style.position='';document.body.style.top='';document.body.style.left='';document.body.style.right='';document.body.style.overflow='';document.documentElement.style.overflow='';window.scrollTo(0,_modalScrollY);}
  // Escape key closes any open UGC modal
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){var m=document.querySelector('[style*="position:fixed"][style*="z-index:99999"]');if(m){_unlockBody();m.remove();}}});
  // Safety: if body is stuck locked but no modal exists, unlock
  setInterval(function(){if(document.body.style.position==='fixed'){var m=document.querySelector('[style*="position:fixed"][style*="z-index:99999"]');if(!m)_unlockBody();}},3000);

  window.openUgcModal=function(items,si){
    _lockBody();
    var el=document.createElement('div');el.style.cssText='position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,0.85);display:flex;justify-content:center;align-items:stretch;';
    var ci=si||0;
    var modalMode='journeys';
    var activeTab='all';
    var mySizesOnly=true;

    function getFiltered(){
      var pool=items;
      if(modalMode==='trimester'){
        if(activeTab!=='all')pool=pool.filter(function(it){return itemStageKey(it)===activeTab;});
        if(mySizesOnly&&sz){
          // Stage-aware size mapping (matches pack-builder logic): post-partum content shows
          // people sized UP by 1 from their pre-pregnancy / pregnancy size. So a user who's M
          // for pregnancy/mum-life should see post-partum UGC where the person is wearing L.
          var SIZE_LADDER=['XXS','XS','S','M','L','XL','XXL','XXXL'];
          var uSz=sz.toUpperCase();
          var uIdx=SIZE_LADDER.indexOf(uSz);
          var uSzUp=uIdx>=0?SIZE_LADDER[Math.min(SIZE_LADDER.length-1,uIdx+1)]:uSz;
          pool=pool.filter(function(it){
            var vals=((it.bottoms||'')+(','+(it.tops||''))).split(',').map(function(s){return s.trim().toUpperCase();}).filter(Boolean);
            if(!vals.length)return true; // include items without size data
            // Determine which size to match against based on the UGC item's stage
            var stageKey=itemStageKey(it); // 't1'/'t2'/'t3'/'p'/'k' or null
            var isPostPartum=stageKey==='p';
            // Post-partum: match user-size or sized-up. Pregnancy/mum-life: just match user-size.
            return vals.indexOf(uSz)>=0||(isPostPartum&&vals.indexOf(uSzUp)>=0);
          });
        }
      }
      return pool;
    }

    // Inject scrollbar-hide style once
    if(!document.getElementById('ugc-modal-style')){
      var st=document.createElement('style');st.id='ugc-modal-style';
      st.textContent='#m-content div::-webkit-scrollbar{display:none;}';
      document.head.appendChild(st);
    }

    function render(){
      var modalUsesSingleProduct=!!PDP_HANDLE;
      var h='<div style="width:100%;background:#000;display:flex;flex-direction:column;height:100%;overflow:hidden;">';
      // Sticky header
      h+='<div style="position:sticky;top:0;z-index:10;background:rgba(0,0,0,0.95);padding:10px 16px 0;">';
      // Top row: close + shop
      h+='<div style="display:flex;justify-content:flex-start;align-items:center;margin:0 0 10px 0;"><button id="mx" style="color:white;background:none;border:none;font-size:20px;cursor:pointer;">\u2715</button></div>';
      // Mode tabs
      h+='<div style="display:flex;gap:0;margin:0 0 8px 0;">';
      h+='<button id="mt-j" style="flex:1;padding:8px;font-size:12px;font-weight:700;border:none;cursor:pointer;'+(modalMode==='journeys'?'background:#E8846C;color:#FFF8E7;':'background:#222;color:#999;')+'">See their journeys</button>';
      h+='<button id="mt-t" style="flex:1;padding:8px;font-size:12px;font-weight:700;border:none;cursor:pointer;'+(modalMode==='trimester'?'background:#E8846C;color:#FFF8E7;':'background:#222;color:#999;')+'">By trimester</button>';
      h+='</div>';
      // Trimester sub-tabs (only in trimester mode)
      if(modalMode==='trimester'){
        h+='<div style="display:flex;gap:4px;overflow-x:auto;scrollbar-width:none;margin:0 0 6px 0;">';
        h+='<button data-tab="all" style="padding:5px 10px;font-size:11px;font-weight:600;border:none;cursor:pointer;white-space:nowrap;'+(activeTab==='all'?'background:white;color:black;':'background:#333;color:#aaa;')+'">All</button>';
        STAGE_ORDER.forEach(function(sk){
          h+='<button data-tab="'+sk+'" style="padding:5px 10px;font-size:11px;font-weight:600;border:none;cursor:pointer;white-space:nowrap;'+(activeTab===sk?'background:white;color:black;':'background:#333;color:#aaa;')+'">'+STAGE_TAB_LABELS[sk]+'</button>';
        });
        h+='</div>';
        h+='<div style="margin:0 0 8px 0;"><label style="display:flex;align-items:center;gap:6px;font-size:11px;color:#aaa;cursor:pointer;"><input type="checkbox" id="m-mysz" '+(mySizesOnly?'checked':'')+' style="accent-color:#E8846C;"> Showing my sizes only</label></div>';
      }
      h+='</div>';

      // Content area
      h+='<div id="m-content" style="flex:1;overflow-y:auto;"></div>';

      // Bottom ATC
      h+='<div style="padding:8px 16px 12px;background:rgba(0,0,0,0.95);">';
      if(!modalUsesSingleProduct)h+='<div id="modal-tiles" style="display:flex;gap:2px;margin:0 0 6px 0;"></div>';
      var __mAtcLabel,__mAtcDisabled=false;
      if(modalUsesSingleProduct){
        __mAtcLabel='Add This Product \u2014 '+S+getPdpSinglePrice();
      } else if(sz){
        var __packState=buildPackAtcLabel();
        __mAtcLabel=__packState.html;
        __mAtcDisabled=__packState.disabled;
      } else {
        __mAtcLabel='Select a size';
      }
      h+='<button id="m-atc"'+(__mAtcDisabled?' disabled':'')+' style="width:100%;padding:14px;background:#E8846C;color:#FFF8E7;font-size:16px;font-weight:700;border:none;cursor:'+(__mAtcDisabled?'not-allowed':'pointer')+';opacity:'+(__mAtcDisabled?'0.55':'1')+';">'+__mAtcLabel+'</button></div>';
      h+='</div>'; // close inner wrapper

      el.innerHTML=h;

      // Render content (use el.querySelector since el isn't in DOM yet)
      var content=el.querySelector('#m-content');
      var filtered=getFiltered();

      if(modalMode==='journeys'){
        // One horizontal carousel per person, scroll down for more people
        var groups={},order=[];
        filtered.forEach(function(it){
          var key=it.handle||('_'+it.id);
          if(!groups[key]){groups[key]=[];order.push(key);}
          groups[key].push(it);
        });

        // Put the focused person first
        var focusedItem=items[ci];
        var focusedHandle=focusedItem?focusedItem.handle||('_'+focusedItem.id):null;
        if(focusedHandle&&order.indexOf(focusedHandle)>0){
          order.splice(order.indexOf(focusedHandle),1);
          order.unshift(focusedHandle);
        }

        order.forEach(function(handle){
          var personItems=groups[handle].sort(stageSort);
          var header=document.createElement('div');
          header.style.cssText='padding:12px 16px 6px;font-size:14px;font-weight:700;color:white;';
          header.textContent='@'+handle;
          content.appendChild(header);
          var track=document.createElement('div');
          track.style.cssText='display:flex;gap:2px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;padding:0 0 12px 0;';
          var scrollToCard=null;
          personItems.forEach(function(it){
            var card=document.createElement('div');
            var _dsk=window.matchMedia('(min-width:768px)').matches;
            card.style.cssText='flex:0 0 '+(_dsk?'390px':'85%')+';max-width:'+(_dsk?'390px':'85%')+';scroll-snap-align:start;overflow:hidden;background:#000;';
            card.innerHTML=buildCardHtml(it);
            hydrateNormalPriceLines(card);
            if(focusedItem&&it.id===focusedItem.id) scrollToCard=card;
            track.appendChild(card);
          });
          var trackWrap=document.createElement('div');
          trackWrap.style.cssText='position:relative;';
          trackWrap.appendChild(track);
          content.appendChild(trackWrap);
          addScrollArrows(track);
          // Scroll to the focused card within this person's track
          if(scrollToCard){
            setTimeout(function(){scrollToCard.scrollIntoView({behavior:'instant',block:'nearest',inline:'start'});},50);
          }
        });
      } else {
        var sorted=filtered.slice().sort(stageSort);
        sorted.forEach(function(it){
          content.innerHTML+=buildCardHtml(it);
        });
        hydrateNormalPriceLines(content);
      }

      // Add sound buttons and visibility observer to modal videos
      addSoundBtn(el);
      observeNewVideos(el);

      // Hydrate availability for modal badges (swap to "sold out this batch" when variant unavailable)
      hydrateAvailability(el);
      // Wire "add to your set" badges in modal
      el.querySelectorAll('.mes-add-item').forEach(function(badge){
        badge.addEventListener('click',function(e){
          e.stopPropagation();
          if(badge.classList.contains('mes-sold-out'))return;
          addCustomItem(badge.getAttribute('data-handle'),badge.getAttribute('data-name'));
          badge.textContent='added';badge.style.background='#3D9A8B';badge.style.cursor='default';
        });
      });

      // Wire events (use el.querySelector throughout)
      el.querySelector('#mx').addEventListener('click',function(){_unlockBody();el.remove();});
      el.querySelector('#m-atc').addEventListener('click',function(){
        _unlockBody();
        el.remove();
        if(PDP_HANDLE)doPdpSingleAtc(null,['m-atc','atc-sticky']);
        else doAtc();
      });
      if(!modalUsesSingleProduct)renderProgressTiles();
      // Backdrop click to close
      el.addEventListener('click',function(e){if(e.target===el){_unlockBody();el.remove();}});
      el.querySelector('#mt-j').addEventListener('click',function(){modalMode='journeys';activeTab='all';render();});
      el.querySelector('#mt-t').addEventListener('click',function(){modalMode='trimester';render();});
      el.querySelectorAll('[data-tab]').forEach(function(btn){
        btn.addEventListener('click',function(){activeTab=btn.getAttribute('data-tab');render();});
      });
      // My sizes toggle
      var myszCb=el.querySelector('#m-mysz');
      if(myszCb)myszCb.addEventListener('change',function(){mySizesOnly=myszCb.checked;render();});
    }
    document.body.appendChild(el);render();
  };

  // ── Sizing wizard integration ──
  var SIZE_ORDER_LIST=['XXS','XS','S','M','L','XL','XXL','XXXL'];
  var sizingCategories=[];
  var categoryOverrides={}; // key -> {variantId, variantTitle}
  var activeSizingCategory=null;

  try{
    var spData=JSON.parse(document.getElementById('sizing-products-data').textContent);
    sizingCategories=spData.categories||[];
  }catch(e){}

  // Which categories are visible per stage group
  var STAGE_CATEGORIES={
    pregnancy:['mat-bottoms','tops','rec-bottoms'],
    postpartum:['tops','rec-bottoms'],
    mumlife:['ml-bottoms']
  };

  function sizeUp(size){
    var idx=SIZE_ORDER_LIST.indexOf(size);
    if(idx<0||idx>=SIZE_ORDER_LIST.length-1)return size;
    return SIZE_ORDER_LIST[idx+1];
  }

  function defaultSizeForCategory(cat){
    if(!sz)return null;
    if(cat.sizeRule==='up1')return sizeUp(sz);
    return sz;
  }

  function renderSizeSummary(){
    var container=document.getElementById('size-summary');
    var wrap=document.getElementById('size-summary-wrap');
    var colEl=document.getElementById('size-summary-collapsed');
    if(!container)return;
    if(!sz){if(wrap)wrap.style.display='none';return;}

    var sg=getStageGroup(tri);
    var visible=STAGE_CATEGORIES[sg]||STAGE_CATEGORIES.pregnancy;
    var cats=sizingCategories.filter(function(c){return visible.indexOf(c.key)>=0;});

    if(!cats.length){if(wrap)wrap.style.display='none';return;}

    var h='<div style="font-size:16px;font-weight:400;color:#fff;letter-spacing:0.14em;margin:0 0 14px 0;">sizes we picked for you</div>';
    cats.forEach(function(cat){
      var override=categoryOverrides[cat.key];
      var displaySize=override?override.variantTitle:defaultSizeForCategory(cat);
      var isOverridden=!!override;
      h+='<div style="display:flex;align-items:center;justify-content:space-between;padding:4px 0;">';
      h+='<span style="font-size:12px;font-weight:300;color:#fff;letter-spacing:0.08em;text-transform:uppercase;">'+cat.label+'</span>';
      h+='<span style="display:flex;align-items:center;gap:8px;">';
      h+='<span style="font-size:18px;font-weight:700;color:#fff;">'+displaySize+'</span>';
      h+='<button type="button" data-sizing-cat="'+cat.key+'" style="font-size:11px;color:rgba(255,255,255,0.6);font-weight:400;background:none;border:none;cursor:pointer;padding:2px 6px;letter-spacing:0.04em;">edit</button>';
      h+='</span></div>';
    });
    if(cats.some(function(c){return c.sizeRule==='up1';})){
      h+='<div style="font-size:11px;font-weight:400;color:#fff;margin-top:10px;letter-spacing:0.02em;">recovery sized up one for compression support post-birth</div>';
    }
    container.innerHTML=h;
    // Show wrapper, start collapsed
    if(wrap){wrap.style.display='';wrap.classList.add('mes-fade-in');}
    if(colEl)colEl.style.display='';
    container.style.display='none';

    // Wire edit buttons
    container.querySelectorAll('[data-sizing-cat]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var catKey=btn.getAttribute('data-sizing-cat');
        openSizingWizard(catKey);
      });
    });
  }

  function openSizingWizard(catKey){
    var cat=null;
    for(var i=0;i<sizingCategories.length;i++){
      if(sizingCategories[i].key===catKey){cat=sizingCategories[i];break;}
    }
    if(!cat)return;
    activeSizingCategory=catKey;

    // Update the global sizing config so the widget picks it up
    window.__convomeshSizingConfig={
      productHandle:cat.handle,
      productTitle:cat.title,
      tenantId:cat.tenantId||TN,
      productType:cat.type||'',
      categoryL1:'Apparel & Accessories',
      categoryL2:'Clothing',
      categoryL3:'Activewear',
      tags:cat.tags||[],
      variants:cat.variants,
      variantConfirmMode:true,
      variantConfirmLabel:cat.label
    };

    // Tell the widget to re-read config
    window.dispatchEvent(new Event('convomesh-sizing-config-updated'));
    // Open the wizard
    setTimeout(function(){
      window.dispatchEvent(new Event('convomesh-open-sizing'));
    },50);
  }

  // Listen for variant confirmation from the wizard
  window.addEventListener('convomesh-variant-confirmed',function(e){
    var detail=e.detail||{};
    if(activeSizingCategory&&detail.variantId){
      categoryOverrides[activeSizingCategory]={
        variantId:detail.variantId,
        variantTitle:detail.variantTitle
      };
      renderSizeSummary();
    }
    activeSizingCategory=null;
  });


  // Override doAtc to use category-specific variants
  var _origDoAtc=doAtc;
  doAtc=function(){
    if(!sz)return;
    var activeQty=getActiveBaseQty();
    var items=[];

    // PDP single-item: add the current product directly
    if(kit==='single'&&PDP_HANDLE&&PDP_VARIANTS){
      var vid=PDP_VARIANTS[sz]||PDP_VARIANTS[sz.toUpperCase()];
      if(!vid){
        // Fallback: try to find any matching variant
        for(var vk in PDP_VARIANTS){if(vk.toUpperCase()===sz.toUpperCase()){vid=PDP_VARIANTS[vk];break;}}
      }
      if(vid){
        items.push({id:Number(vid),quantity:1});
      }
    } else {
      // Map product indices to their sizing category
      var idxToCategory={0:'mat-bottoms',1:'tops',2:'mat-bottoms',3:'rec-bottoms',4:'rec-bottoms',5:'ml-bottoms',6:'ml-bottoms',7:'tops',8:'ml-bottoms'};

      activeQty.forEach(function(q,i){
        if(q<=0||!P[i])return;
        var catKey=idxToCategory[i];
        var override=categoryOverrides[catKey];
        var vid=null;
        if(override){
          vid=override.variantId;
        } else {
          var cat=null;
          for(var ci=0;ci<sizingCategories.length;ci++){
            if(sizingCategories[ci].key===catKey){cat=sizingCategories[ci];break;}
          }
          var targetSz=cat?defaultSizeForCategory(cat):sz;
          vid=P[i].v?P[i].v[targetSz]:null;
          if(!vid&&P[i].v)vid=P[i].v[sz];
        }
        if(vid)items.push({id:Number(vid),quantity:q});
      });

      customItems.forEach(function(ci){
        if(ci.qty>0&&ci.variantId)items.push({id:ci.variantId,quantity:ci.qty});
      });
    }
    if(!items.length)return;
    ['atc','atc2','atc-sticky'].forEach(function(id){var b=document.getElementById(id);if(b){b.disabled=true;b.textContent='Adding...';}});
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){return r.json();})
    .then(function(){if(kit==='single'){document.getElementById('upsell').style.display='flex';updAtc();}else{window.location.href='/cart';}})
    .catch(function(){['atc','atc2','atc-sticky'].forEach(function(id){var b=document.getElementById(id);if(b){b.disabled=false;b.textContent='Something went wrong';}});});
  };

  rebuildKits();
  bindNativePdpPickerSync();
  syncSizeFromNativePdpPicker({refresh:false});
  seedPdpInitialSelection();
  renderStageUI();
  if(PDP_HANDLE)refreshPackUi();
  else if(kit==='custom')refreshPackUi();
  else pickKit('prepared');

})();
